import { DatePipe } from '@angular/common';
import { Component, OnInit, Injector } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { NgbDateParserFormatter, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { DateFormatTransferService } from 'src/app/services/date-format-transfer.service';
import { EntitlementService } from 'src/app/services/entitlement.service';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { ContentService } from 'src/app/services/content.service';
import { ExportService } from 'src/app/services/export.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';
import { SuccessComponent } from '../../../shared/components/success/success.component';
import { PDLService } from 'src/app/services/pdl-service.service';
import {
  BULK_UPLOAD, COMMON_CONSTANTS, ENTITLEMENT_ACTIVITYNAMES, LINE_IDENTIFIER, MANAGE_LINE_CONST, MANAGE_MODAL_CONST,
  MSISDN_CHANGE_REASONS, SIM_CHANGE_CONST, SUSPEND_CONSTANTS, VALUE, ANALYTICS, CANCEL_SUBSCRIBER_REASONS, EXCEL_JS, GENERIC_ERROR_MSGS, SIM_SWAP_REASONS, TRANSFER_NUMBER_CONSTANTS
} from '../../../common/core/common.constants';
import { simChangeReason } from '../../../common/models/column-defintion.model';
import {
  BulkRequestsForLineIdentifier, BulkRequestsForRestore, MultiLineBulkPortinHeaders, MultiLineBulkSwapHeaders, MultiLineHeaders,
  Requests, RequestsBulkLine, RequestsBulkLineIdentifier, RequestsBulkPortin, RequestsBulkSwap
} from '../../../common/models/data.model';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { environment } from 'src/environments/environment';
import { AlertConfirmPopupComponent } from 'src/app/common/alert-confirm-popup';
import { ConfirmOrCancelModalComponent } from 'src/app/shared/components/confirm-or-cancel-modal/confirm-or-cancel-modal.component';
import * as jose from 'jose';
import { combineLatest } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-submit-bulk-upload',
  templateUrl: './submit-bulk-upload.component.html',
  styleUrls: ['./submit-bulk-upload.component.scss'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: DateFormatTransferService },
  ],
})
export class SubmitBulkUploadComponent implements OnInit {
  authoringContentData: any;
  changePhoneTemplate: any = [];
  JSonExcel: any;
  bulkFlow: string;
  title: string;
  subheader: string;
  bulkOrInlineFlow: boolean;
  selectedLines: any;
  worksheetname: string;
  uploadJsonData: any = [];
  requests: any = [];
  requestBody: any = [];
  bulkUploadlength: any;
  blkUpldSubmittitle: string;
  selectsubmitCheckBox = false;
  checkBoxDisabled = true;
  termsAndConditionCheckBox = false;
  ngbModalOptions: NgbModalOptions;
  subscriberStatusSucces: number;
  logonData: any;
  restoreFlow: string;
  suspendFlow: string;
  changeNumberFlow = false;
  changeReasonForm = new UntypedFormControl('', [Validators.required]);
  changeAreaCodeForm = new UntypedFormControl('', [Validators.required]);
  simSwapFlow: string;
  restoreErrorMsg: string;
  cancelSubscriberFlow: string;
  restoreLines: any = [];
  linesWithError: any = [];
  tempLineWithError: any = [];
  reviewMsg: string;
  itemLoadedSuccfully: any;
  itmeNotLoadeSuccefully: any;
  minimumDate: any;
  validationError = false;
  validationSimSwapError = false;
  linesWithErrorDuplicate: any = [];
  bulkUploadFailedlength: any;
  errorSubheader: any;
  blkUpldChangeNumberTitle: string;
  templateType: any;
  bulkUploadFailedFlag = false;
  reasons: any;
  regex19 = SIM_CHANGE_CONST.REGEX19;
  regex20 = SIM_CHANGE_CONST.REGEX20;
  regex32 = SIM_CHANGE_CONST.REGEX32;
  multiSimChange = [];
  bulkSuccesslines = [];
  multiLineBulkSwapHeaders: MultiLineBulkSwapHeaders = new MultiLineBulkSwapHeaders();
  requestsBulkSwap: RequestsBulkSwap = new RequestsBulkSwap();
  requestSimChange: any;
  bulkJsonData: any;
  unValidatedChangeNumberItems;
  unValidatedChangeNumberItemsFinal;
  msisdnChangeReasons: any = MSISDN_CHANGE_REASONS;
  suspendendeLines = [];
  multiLineHeaders: MultiLineHeaders = new MultiLineHeaders();
  resonErrorInline: any;
  approverTypeList: any;
  approverType: any;
  selectedReason: any;
  aproverErrorInline: any;
  requestHeaders: any;
  isLoaderOn: boolean;
  results: any;
  orgId: any;
  maxDate: any;
  transferNumberLines: any = [];
  validChangeNumberLines: any = [];
  validSimSwapLines: any = [];
  validLineIdentifierLines: any = [];
  isTransferNumberFlow: boolean;
  isChangeNumberFlow: boolean;
  isSimSwapFlow: boolean;
  isRestoreFlow: boolean;
  isSuspendFlow: boolean;
  isLineIdentifierFlow: boolean;
  isCancelSubscriberFlow: boolean;
  isChangeServiceFlow: boolean;
  isManagePairingFlow: boolean;
  isStrategicPortInFlow: boolean;
  issuesFound: number;
  portinLines: any = [];
  multiLineBulkPortinHeaders: MultiLineBulkPortinHeaders = new MultiLineBulkPortinHeaders();
  requestPortin: any;
  requestsBulkPortin: RequestsBulkPortin = new RequestsBulkPortin();
  maximumTransferDate: any;
  minimumTransferDate: any;
  isLineValidated = false;
  userId: any;
  isReadOnlyForOkta  = {simSwap: false, suspend: false, restore: false, changeNumber: false, portIn: false, lineIdentifier: false};
  applyToAll: any;
  elstConstant: any;
  edusConstant: any;
  imsConstant: any;
  mimsConstant: any;
  suncConstant: any;
  tncCheckBox: boolean;
  ssqConstant: any;
  manageLineService: ManageLineService;
  modalService: NgbModal;
  utilsSvc: UtilsService;
  exportSvc: ExportService;
  datePipe: DatePipe;
  contentService: ContentService;
  _cacheSvc: HttpCacheService;
  _loaderSvc: LoaderService
  entitlementSvc: EntitlementService;
  _helperUtilSvc: HelperUtilityService;
  pdlService: PDLService;
  eSimEnabled:boolean = environment.ENABLE_ESIM;
  enableCupNoRegrets = environment.ENABLE_CUP_NOREGRETS_UDF;
  cancelLines: any [];
  changeServices: any [];
  isSpectrumBarterBan: boolean = false;
  managePairLines: any [];
  strategicPortInLines: any [];
  showTimeErrorBelowReviewStatement = false;
  router: Router;
  isUDFDormancyEnabled = environment.ENABLE_UDF_AHUB_2;

  constructor(private injector : Injector) {
     this.manageLineService = this.injector.get<ManageLineService>(ManageLineService);
     this.modalService = this.injector.get<NgbModal>(NgbModal);
     this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
     this.exportSvc = this.injector.get<ExportService>(ExportService);
     this.datePipe = this.injector.get<DatePipe>(DatePipe);
     this.contentService = this.injector.get<ContentService>(ContentService);
     this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
      this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
      this.entitlementSvc = this.injector.get<EntitlementService>(EntitlementService);
      this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
      this.pdlService = this.injector.get<PDLService>(PDLService);
      this.router = this.injector.get<Router>(Router);
   }

  ngOnInit() {
    this.isTransferNumberFlow = false;
    this.isChangeNumberFlow = false;
    this.isSimSwapFlow = false;
    this.isRestoreFlow = false;
    this.isSuspendFlow = false;
    this.isCancelSubscriberFlow = false;
    this.subscriberStatusSucces = COMMON_CONSTANTS.DIGITS.ZERO;
    this.restoreFlow = BULK_UPLOAD.RESTORE_KEY;
    this.suspendFlow = BULK_UPLOAD.SUSPEND_KEY;
    this.simSwapFlow = BULK_UPLOAD.SIM_SWAP_KEY;
    this.cancelSubscriberFlow = BULK_UPLOAD.CANCEL_SUBSCRIBER;
    this.logonData = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    this.isSpectrumBarterBan = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.IS_SPECTRUM_BARTER));
    this.authoringContentData = this.utilsSvc.getContentDataFromSession();
    this.templateType = ContentService.GetCache(BULK_UPLOAD.TEMPLATE_KEY);
    this.bulkJsonData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);
    this.unValidatedChangeNumberItems = _.filter(this.bulkJsonData, { validated: false });
    this.unValidatedChangeNumberItemsFinal = _.filter(this.bulkJsonData, { validated: false });
    this.orgId = this._helperUtilSvc.getOrgID();
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };
    this.bulkOrInlineFlow = ContentService.GetCache(BULK_UPLOAD.BULK_OR_INLINE_FLOW);
    this.bulkFlow = ContentService.GetCache(BULK_UPLOAD.BULK_FLOW_KEY);
    this.changeNumberFlow = this.bulkFlow === BULK_UPLOAD.CHANGE_PHONE_KEY;

    this.bulkUploadlength = ContentService.GetCache(COMMON_CONSTANTS.LENGTH_TXT);
    this.bulkUploadFailedlength = ContentService.GetCache(BULK_UPLOAD.FAILEDROWS_LENGTH_TXT);
    if (this.bulkFlow === BULK_UPLOAD.RESTORE_KEY || this.bulkFlow === BULK_UPLOAD.SUSPEND_KEY) {
      this.bulkUploadFailedlength = 0;
    }
    if (!isNullOrUndefined(this.bulkUploadFailedlength) && this.bulkUploadFailedlength > 0) {
      // tslint:disable-next-line:max-line-length
      this.blkUpldSubmittitle = this.bulkUploadlength + this.authoringContentData.bulkFlow.itemsLoadedTxt + ', ' + this.bulkUploadFailedlength + this.authoringContentData.bulkFlow.bulkInlineflowIssuesTxt;
      this.subheader = (this.bulkUploadlength - this.bulkUploadFailedlength) + this.authoringContentData.bulkFlow.itemsLoadedSucessTxt;
      this.errorSubheader = this.bulkUploadFailedlength + this.authoringContentData.bulkFlow.bulkInlineflowIssuesTxt;
      this.blkUpldChangeNumberTitle = this.bulkUploadlength - this.bulkUploadFailedlength +
        this.authoringContentData.changeNumberAuthoring.itemLoaded + this.bulkUploadFailedlength +
        this.authoringContentData.changeNumberAuthoring.issuesFound;
      this.bulkUploadFailedFlag = true;
    } else {
      this.blkUpldSubmittitle = this.bulkUploadlength + this.authoringContentData.bulkFlow.itemsLoadedTxt;
      this.subheader = this.bulkUploadlength + this.authoringContentData.bulkFlow.itemsLoadedSucessTxt;
      this.blkUpldChangeNumberTitle = this.bulkUploadlength + this.authoringContentData.bulkFlow.itemsLoadedTxt;
    }
    this.userId = this._helperUtilSvc.getUserId();

    switch (this.bulkFlow) {
      case BULK_UPLOAD.CHANGE_PHONE_KEY:
        this.linesWithError = [];
        this.isChangeNumberFlow = true;
        this.changeNumberFlow = true;
        this.changeNumberData();
        break;
      case BULK_UPLOAD.SIM_SWAP_KEY:
        this.isSimSwapFlow = true;
        this.checkingSimSwapDataValidation();
        break;
      case BULK_UPLOAD.SUSPEND_KEY:
        this.isSuspendFlow = true;
        this.linesWithError = [];
        this.checkingSuspendDataValidation();
        break;
      case BULK_UPLOAD.RESTORE_KEY:
        this.isRestoreFlow = true;
        this.linesWithError = [];
        this.checkingRestoreDataValidation();
        break;
      case BULK_UPLOAD.TRANSFER_NUMBERS:
        this.linesWithError = [];
        this.isTransferNumberFlow = true;
        this.transferNumberData();
        this.generateModalViewTag();
        break;
      case BULK_UPLOAD.LINE_IDENTIFIER:
        this.isLineIdentifierFlow = true;
        this.linesWithError = [];
        this.checkingLineIDentifierValidation();
        break;
      case BULK_UPLOAD.CANCEL_SUBSCRIBER:
        this.isCancelSubscriberFlow = true;
        this.linesWithError = [];
        this.cancelLines = [];
        this.checkingCancelSubscriberValidation();
        break;
      case BULK_UPLOAD.CHANGE_SERVICE:
        this.isChangeServiceFlow = true;
        this.linesWithError = [];
        this.changeServices = [];
        this.checkingChangeServiceValidation();
        break;
      case BULK_UPLOAD.MANAGE_PAIRING:
        this.isManagePairingFlow = true;
        this.linesWithError = [];
        this.managePairLines = [];
        this.checkingManagePairingValidation();
        break;
      case BULK_UPLOAD.STRATEGIC_PORT_IN:
        this.isStrategicPortInFlow = true;
        this.linesWithError = [];
        this.strategicPortInLines = [];
        this.checkingStrategicPortInValidation();
        break;
    }
    this._loaderSvc.stop();
    this.setReadOnlyFlags();
    this.checkIsSpectrumBarterAndEnableSubmit();
  }

  checkIsSpectrumBarterAndEnableSubmit() {
    if (environment.ENABLE_SPECTRUM && this.isSpectrumBarterBan) {
      this.selectsubmitCheckBox = true;
    }
  }

  dateHasExpectedFormat(dateStr) {
    const monthDayYearArr = dateStr.split("/");
    if (monthDayYearArr.length != 3) {
      return false;
    }
    return true;
  }

  getSelectedBanMsisdns() {
    const data = this._cacheSvc.getFromSessionStorage(BULK_UPLOAD.SELECTED_BAN_MSISDNS) || [];
    return new Set(JSON.parse(data));
  }

  checkingCancelSubscriberValidation() {
    this.uploadJsonData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);

    const codeReasonMap = this.makeCancelSubscriberReasonCodeMap();
    const mobileNumberSet = this.getSelectedBanMsisdns();

    this.reasons = CANCEL_SUBSCRIBER_REASONS;
    for (const line of this.uploadJsonData) {
      if (mobileNumberSet.size != 0 && !mobileNumberSet.has(line.PhoneNumber)) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_BAN_MSISDN_MISMATCH;
        this.linesWithError.push(line);
        continue;
      }
      if (!this.dateHasExpectedFormat(line.Cancel_date) ) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_RESTORE_KEY;
        this.linesWithError.push(line);
        continue;
      } else if (!this.isDateTodayOrLater(line.Cancel_date)  ) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = this.authoringContentData.bulkFlow.startDateErrTxt;
        this.linesWithError.push(line);
        continue;
      }
      if (codeReasonMap[line.Cancel_reason] == undefined) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = this.authoringContentData.bulkFlow.reasonErrTxt;
        this.linesWithError.push(line);
        continue;
      }
      // Line had no errors
      line.errorValidator = false;
      line.succesValidator = true;
      this.cancelLines.push(line);
    }
    this.runPreSubmitCheckForCancelSubscriber();
  }

  submitButtonClicked() {
    switch (this.bulkFlow) {
      case BULK_UPLOAD.CHANGE_PHONE_KEY:
        this.submitChangeNumberDataAfterUpload();
        break;
      case BULK_UPLOAD.SIM_SWAP_KEY:
        this.submitSimSwapDataAfterUpload();
        break;
      case BULK_UPLOAD.SUSPEND_KEY:
        this.submitSuspendDataAfterUpload();
        break;
      case BULK_UPLOAD.RESTORE_KEY:
        this.submitRestoreDataAfterUpload();
        break;
      case BULK_UPLOAD.LINE_IDENTIFIER:
        this.submitLineIdentifierDataAfterUpload();
        break;
      case BULK_UPLOAD.CANCEL_SUBSCRIBER:
        this.submitCancelSubscriberDataAfterUpload();
        break;
      case BULK_UPLOAD.CHANGE_SERVICE:
        this.submitChangeServiceDataAfterUpload();
        break;
      case BULK_UPLOAD.MANAGE_PAIRING:
        this.submitManagePairingDataAfterUpload();
        break;
      case BULK_UPLOAD.STRATEGIC_PORT_IN:
        this.submitStrategicPortInDataAfterUpload();
        break;
    }
  }

  setReadOnlyFlags(){
    this.isReadOnlyForOkta.changeNumber = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.CHANGE_NUMBER_BULK);
    this.isReadOnlyForOkta.simSwap = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.SIM_SWAP_BULK);
    this.isReadOnlyForOkta.restore = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.RESTORE_BULK);
    this.isReadOnlyForOkta.suspend = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.SUSPEND_BULK);
    this.isReadOnlyForOkta.lineIdentifier = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.LINE_IDENTIFIER_BULK);
    this.isReadOnlyForOkta.portIn = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.PORT_IN);
  }

  submitSimSwapDataAfterUpload() {
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };
    this.multiLineBulkSwapHeaders.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
    this.multiLineBulkSwapHeaders.targetServiceName = SIM_CHANGE_CONST.SIM_SWAP_TXT;
    this.updatedSimBulkRequestHeader();
    this.requestSimChange = this.multiLineBulkSwapHeaders;
    this._loaderSvc.start();
    this.manageLineService.bulkSimChangeProcessor(this.requestSimChange).subscribe((response: any) => {
      this._loaderSvc.stop();
      if (!isNullOrUndefined(response) && !isNullOrUndefined(response.status)
        && response.status === SIM_CHANGE_CONST.SUCCESS) {
        this.manageLineService.close();
        const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
        successModalRef.componentInstance.bulkSimSwapData = this.multiLineBulkSwapHeaders;
        // tslint:disable-next-line: prefer-for-of
        for (let index = 0; index < this.restoreLines.length; index++) {
          // tslint:disable-next-line: max-line-length
          successModalRef.componentInstance.bulkSimSwapData.requests[index][BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt] = !isNullOrUndefined(this.restoreLines[index].OldSim) && this.restoreLines[index].OldSim !== '' ? this.restoreLines[index].OldSim : '';
        }
        successModalRef.componentInstance.token = response.token;
        successModalRef.componentInstance.header = this.authoringContentData.changeSim.simChangeRequestComplete;
        successModalRef.componentInstance.bulkUploadFlow = true;
        successModalRef.componentInstance.flowType = BULK_UPLOAD.SIM_SWAP_KEY;
      }
    }, (err) => {
      this._loaderSvc.stop();
      this.utilsSvc.errorHandling(err);
    });
  }

  updatedSimBulkRequestHeader() {
    const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    for (let index = 0; index < this.restoreLines.length; index++) {
      this.requestsBulkSwap = new RequestsBulkSwap();
      this.requestsBulkSwap.orgId = this._helperUtilSvc.getOrgID();
      this.requestsBulkSwap.logonId = !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID;
      this.requestsBulkSwap.email = !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID;
      this.newSimParam(index);
      this.reasonCodeParam(index);
      this.msisdnParam(index);
      this.multiLineBulkSwapHeaders.requests[index] = this.requestsBulkSwap;
    }
  }
 reasonCodeParam(index){
  if(this.utilsSvc.isNotNullOrUndefined(this.restoreLines[index].Reason_For_Change)){
    this.requestsBulkSwap.reasonCode = this.getReasonCode(this.restoreLines[index].Reason_For_Change);
  }else if(this.utilsSvc.isNotNullOrUndefined(this.restoreLines[index].reasonCode)){
    this.requestsBulkSwap.reasonCode = this.restoreLines[index].reasonCode;
  }else{
    this.requestsBulkSwap.reasonCode = '';
  }
 }
  newSimParamForEsimEnabled(index){
    if(this.utilsSvc.isNotNullOrUndefined(this.restoreLines[index][BULK_UPLOAD.BULK_SIMSWAP_EID_Txt]) && this.restoreLines[index][BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] !== ""){
      this.requestsBulkSwap.eid = this.restoreLines[index][BULK_UPLOAD.BULK_SIMSWAP_EID_Txt];
    }else if(this.utilsSvc.isNotNullOrUndefined(this.restoreLines[index][BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt]) && this.restoreLines[index][BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] !== ""){
      this.requestsBulkSwap.newSim = this.restoreLines[index][BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt];
    }else if(this.restoreLines[index].newSim !== '' || this.restoreLines[index].eid !== ''){
      if(this.utilsSvc.isNotNullOrUndefined(this.restoreLines[index].newSim) && (this.regex19.test(this.restoreLines[index].newSim) || this.regex20.test(this.restoreLines[index].newSim))){
        this.requestsBulkSwap.newSim = this.restoreLines[index].newSim;
      }
      if(this.utilsSvc.isNotNullOrUndefined(this.restoreLines[index].eid) && this.restoreLines[index].eid.length == SIM_CHANGE_CONST.E_SIM_NUM_LENGTH){
        this.requestsBulkSwap.eid = this.restoreLines[index].eid;
      }
    }else{
      this.requestsBulkSwap.newSim = '';
    }
  }
  newSimParam(index){
    if(this.eSimEnabled){
     this.newSimParamForEsimEnabled(index);
    }else if(this.utilsSvc.isNotNullOrUndefined(this.restoreLines[index].newSim) && this.restoreLines[index].newSim !== ''){
      this.requestsBulkSwap.newSim = this.restoreLines[index].newSim;
    }else if(this.utilsSvc.isNotNullOrUndefined(this.restoreLines[index].NewSim) && this.restoreLines[index].NewSim !== ''){
      this.requestsBulkSwap.newSim = this.restoreLines[index].NewSim;
    }else{
      this.requestsBulkSwap.newSim = '';
    }
  }
  msisdnParam(index){
    if(this.utilsSvc.isNotNullOrUndefined(this.restoreLines[index].PhoneNumber)){
      this.requestsBulkSwap.msisdn = this.restoreLines[index].PhoneNumber;
    }else if(this.utilsSvc.isNotNullOrUndefined(this.restoreLines[index].msisdn)){
      this.requestsBulkSwap.msisdn = this.restoreLines[index].msisdn;
    }else{
      this.requestsBulkSwap.msisdn = '';
    }
  }
  getReasonCode(reason: string) {
    if (!isNullOrUndefined(reason) && reason !== '') {
      switch (reason) {
        case BULK_UPLOAD.CUSTOMER_SIM_SIM_IN_KIT: return BULK_UPLOAD.SIM_CHANGE_REASON_BYOS;
        case BULK_UPLOAD.CUSTOMER_EMPLOYEE_REQUEST: return BULK_UPLOAD.SIM_CHANGE_REASON_CR;
        case BULK_UPLOAD.VALIDATED_DEFECTIVE_SIM: return BULK_UPLOAD.SIM_CHANGE_REASON_DFS;
        case BULK_UPLOAD.LOST_STOLEN_DAMAGED_SIM: return BULK_UPLOAD.SIM_CHANGE_REASON_LS;
      }
    } else {
      return '';
    }
  }

  submitChangeNumberDataAfterUpload() {
    const requestPayLoad = {
      targetServiceName: 'change-msdn',
      ban: this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN),
      requests: this.transformRequestBody(),
    };
    this._loaderSvc.start();
    this.manageLineService.bulkChangeNmberProcessor(requestPayLoad).subscribe((data) => {
    this._loaderSvc.stop();
      this.manageLineService.close();
      const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
      successModalRef.componentInstance.bulkOrderStatus = data;
      successModalRef.componentInstance.header = this.authoringContentData.changeNumberAuthoring.successModalTitle;
      successModalRef.componentInstance.bulkChangeNumberData = this.uploadJsonData;
      successModalRef.componentInstance.bulkUploadFlow = true;
      successModalRef.componentInstance.flowType = BULK_UPLOAD.CHANGE_PHONE_KEY;

    }, (error) => {
      this.showError(error);
    });


    let submitCTAName = this.authoringContentData.changeNumberAuthoring.submitChange;
    if (this.bulkUploadFailedFlag) {
      submitCTAName= this.authoringContentData.changeNumberAuthoring.submitSuccessfulItems;
    }

    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: submitCTAName,
      assetType: ANALYTICS.BUTTON,
      modalName:ANALYTICS.BULK_CHANGE_NUMBER,
      userSelection:''
    });
  }

  showError(error : any){
    this._loaderSvc.stop();
      this.manageLineService.close();
      this.utilsSvc.errorHandling(error);
  }
  createSubmitPayloadLineIdentifier(){
    const configModel = this.utilsSvc.createConfigModel();
    const bulkLineIdentifierRequestPayload = new BulkRequestsForLineIdentifier();
      bulkLineIdentifierRequestPayload.targetServiceName = LINE_IDENTIFIER.TARGET_SERVICE_NAME;
      bulkLineIdentifierRequestPayload.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
      this.validLineIdentifierLines.forEach((line) => {
        const bulkJsonData = new RequestsBulkLineIdentifier();
        bulkJsonData.orgId = this._helperUtilSvc.getOrgID();
        bulkJsonData.logonId = this.logonData?.logonID || COMMON_CONSTANTS.LOGON_ID;
        bulkJsonData.email = this.logonData?.logonEmail || COMMON_CONSTANTS.LOGON_ID;
        bulkJsonData.msisdn = line.PhoneNumber;
        bulkJsonData.userId = this.userId;
        bulkJsonData.ban = line.Ban;
        configModel?.forEach((config) => {
          if(environment.ENABLE_DH_UDF && config.configName == LINE_IDENTIFIER.CONFIG_UDFID6){
            if(this.templateType === BULK_UPLOAD.CSV_TXT){
              bulkJsonData[config.configName] = line[this.authoringContentData.bulkFlow.bulkUploadUDFExtraColumnDescription + COMMON_CONSTANTS.NEW_LINE + BULK_UPLOAD.UPDATED_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim()];
            } else {
              bulkJsonData[config.configName] = line[this.authoringContentData.bulkFlow.bulkUploadUDFExtraColumnDescription + COMMON_CONSTANTS.NEW_LINE_R + BULK_UPLOAD.UPDATED_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim()];
            }
          } else {
            bulkJsonData[config.configName] = line[BULK_UPLOAD.UPDATED_TXT + COMMON_CONSTANTS.STRING_SPACE + (config.configLabel + COMMON_CONSTANTS.STRING_SPACE + config.configDesc).trim()];
          }
        });
        bulkLineIdentifierRequestPayload.requests.push(bulkJsonData);
      });
      return bulkLineIdentifierRequestPayload;
  }
  submitLineIdentifierDataAfterUpload() {
    if (this.validLineIdentifierLines) {
      const bulkLineIdentifierRequestPayload = this.createSubmitPayloadLineIdentifier();
      this._loaderSvc.start();
      this.manageLineService.bulkLineIdentifierProcessor(bulkLineIdentifierRequestPayload).subscribe((response) => {
        this._loaderSvc.stop();
        if (response.token && response.status === MANAGE_LINE_CONST.SUCCESS) {
          this.lineIdentifierSuccess(response.token);
        }
      }, (error) => {
        this.showError(error);
      });

      this.pdlService.ifEnabledGenerateClickTag({
        type: ANALYTICS.CLICK_TO_ACTION,
        action: ANALYTICS.CLICK,
        ctaName: this.authoringContentData.changeNumberAuthoring.submitChange,
        assetType: ANALYTICS.BUTTON,
        modalName: ANALYTICS.BULK_UPDATE_LINE_IDENTIFIER,
        userSelection: ''
      });
    }
  }

  lineIdentifierSuccess(token) {
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };
    if (!isNullOrUndefined(token)) {
      this.manageLineService.close();
      const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
      successModalRef.componentInstance.modalBodyContent = !isNullOrUndefined(this.authoringContentData.lineIdentifierAuthoring.confirmationMsgTxt) ?
        this.authoringContentData.lineIdentifierAuthoring.confirmationMsgTxt.replace('{{transaction}}', token) : '';
      successModalRef.componentInstance.header = !isNullOrUndefined(this.authoringContentData.lineIdentifierAuthoring.lineIdentifierSuccessTxt) ?
        this.authoringContentData.lineIdentifierAuthoring.lineIdentifierSuccessTxt : '';
    }
  }

  transformRequestBody() {

    this.uploadJsonData = [...this.uploadJsonData[0]];
    const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    return _.map(this.uploadJsonData, (data) => {
      const validate: any = _.find(MSISDN_CHANGE_REASONS, { description: data.Reason_For_Change });
      return {
        email: !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID,
        logonId: !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID,
        npa: data.Preferred_Area_Code,
        oldMsisdn: data.PhoneNumber,
        orgId: this.orgId, // API_PARAMS_CONST.B2B_ORG_ID,
        reasonCode: validate.code,
        reasonId: validate.id,
        ban: this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN),
      };
    });
  }

  validateRestoreData() {
    const dateFuture = new Date();
    const futureEligibleDate = new Date(dateFuture.setDate(dateFuture.getDate() + 365));

    for (const line of this.uploadJsonData) {
      line.succesValidator = false;
      line.errorValidator = false;
      line.errorMsg = '';
      if (line?.RestoreDate && line.RestoreDate !== '') {
        const restoreDate = new Date(line.RestoreDate);
        if (this.isDateSmallerThanToday(restoreDate)) {
          this.setErrorinFile(line, futureEligibleDate);
        } else if (futureEligibleDate >= restoreDate) {
          this.restoreLines.push(line);
        } else {
          this.setErrorinFile(line, futureEligibleDate);
        }
      } else {
        this.setErrorinFile(line, futureEligibleDate);
      }
    }
  }

  checkingRestoreDataValidation() {
    this.linesWithError = [];
    this.restoreLines = [];
    this.uploadJsonData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);

    if (!isNullOrUndefined(this.uploadJsonData)) {
      this.validateRestoreData();
    }
    if (!isNullOrUndefined(this.linesWithError) && this.linesWithError.length > 0) {
      this.expansionPanelOpened(this.linesWithError[0]);
      this.linesWithErrorDuplicate = this.linesWithError.map((x) => Object.assign({}, x));
      this.validationError = true;
      const currentDat = new Date();
      this.minimumDate = {
        year: currentDat.getFullYear(), month: currentDat.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
        day: currentDat.getDate(),
      };
      this.maxDate = {
        year: currentDat.getFullYear() + 1, month: currentDat.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
        day: currentDat.getDate(),
      };
      this.blkUpldSubmittitle = this.restoreLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.restoreLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
    }
    if (!isNullOrUndefined(this.restoreLines) && this.restoreLines.length === 0) {
      this.termsAndConditionCheckBox = true;
    } else {
      this.termsAndConditionCheckBox = false;
    }
    ContentService.SetCache(BULK_UPLOAD.RESTORE_SUCCESS_DATA, this.restoreLines);
  }

  setErrorinFile(line, restoreDate) {
    line.succesValidator = false;
    line.errorValidator = true;
    line.errorMsg = !isNullOrUndefined(this.authoringContentData && this.authoringContentData.manageLineRestore &&
      this.authoringContentData.manageLineRestore.bulkRestoreDateErrTxt) ?
      this.authoringContentData.manageLineRestore.bulkRestoreDateErrTxt : '';
    line.multiRestoreDate = '';
    this.linesWithError.push(line);
  }

  multiplRestoreDateSelected(line) {
    if (!isNullOrUndefined(line) && !isNullOrUndefined(line.multiRestoreDate) && !isNullOrUndefined(line.multiRestoreDate.year) &&
      !isNullOrUndefined(line.multiRestoreDate.month) && !isNullOrUndefined(line.multiRestoreDate.day) &&
      !isNullOrUndefined(this.datePipe)) {
      line.RestoreDate = this.datePipe.transform(new Date(line.multiRestoreDate.year,
        line.multiRestoreDate.month - COMMON_CONSTANTS.DIGITS.ONE, line.multiRestoreDate.day), MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
      this.checkingWithDuplicateError(line);
      line.succesValidator = true;
      line.errorValidator = false;
      const index = this.restoreLines.findIndex((item) => item.PhoneNumber === line.PhoneNumber);
      if (index === -1) {
        this.restoreLines.push(line);
      }
      if (!isNullOrUndefined(this.linesWithErrorDuplicate) && this.linesWithErrorDuplicate.length > 0) {
        this.blkUpldSubmittitle = this.restoreLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt
          + this.linesWithErrorDuplicate.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
        this.itmeNotLoadeSuccefully = this.linesWithErrorDuplicate.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      } else {
        this.blkUpldSubmittitle = this.restoreLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedWithOutTxt;
        this.itmeNotLoadeSuccefully = '';
      }
      this.itemLoadedSuccfully = this.restoreLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
    }
    if (!isNullOrUndefined(this.restoreLines) && this.restoreLines.length === 0) {
      this.termsAndConditionCheckBox = true;
    } else {
      this.termsAndConditionCheckBox = false;
    }
  }

  checkingWithDuplicateError(line){
    if (!isNullOrUndefined(this.linesWithErrorDuplicate)) {
      const indexPhoneNumber = this.linesWithErrorDuplicate.findIndex((item) => item.PhoneNumber === line.PhoneNumber);
      if (indexPhoneNumber >= 0) {
        this.linesWithErrorDuplicate.splice(indexPhoneNumber, 1);
      }
    }
  }

  submitRestoreDataAfterUpload() {
    this.requests = [];
    this.subscriberStatusSucces = COMMON_CONSTANTS.DIGITS.ZERO;
    if (this.restoreLines && this.restoreLines.length > 0 && this.uploadJsonData && this.uploadJsonData.length > 0) {
      this._loaderSvc.start();
      this.uploadJsonData.forEach((element) => {
          this.getSubscriberStatus(element);
      });
      this.pdlService.ifEnabledGenerateClickTag({
        type: ANALYTICS.CLICK_TO_ACTION,
        action: ANALYTICS.CLICK,
        ctaName: this.authoringContentData.changeNumberAuthoring.submitChange,
        assetType: ANALYTICS.BUTTON,
        modalName:ANALYTICS.BULK_RESTORE,
        userSelection:''
      });
    }
  }

  // when expansion panel is closed we are showing message
  expansionPanelClosed(line) {
    line.msgShowOnPanel = true;
    line.expendFlagValue = false;
  }
  // when expansaion panel is open we are hiding message
  expansionPanelOpened(line) {
    line.msgShowOnPanel = false;
    line.expendFlagValue = true;
  }
  // restore next step
  nextStep(line) {
    const nextIndex = this.linesWithError.findIndex((item) => item.msisdn === line.msisdn);
    this.linesWithError[nextIndex].expendFlagValue = false;
    this.linesWithError[nextIndex + 1].expendFlagValue = true;
  }

  nextStepRestore(line) {
    const nextIndex = this.linesWithError.findIndex((item) => item.PhoneNumber === line.PhoneNumber);
    this.linesWithError[nextIndex].expendFlagValue = false;
    this.linesWithError[nextIndex + 1].expendFlagValue = true;
  }

  getSubscriberStatus(line): void {
    if (!isNullOrUndefined(line) && !isNullOrUndefined(line.PhoneNumber)) {
      this.manageLineService.getSubscriberStatus(line.PhoneNumber).subscribe(
        (subscriberStatusRes) => {
          this.subscriberStatusResponse(line, subscriberStatusRes);
        },
        (subscriberError) => {
          this.subscriberStatusSucces++;
          line.showErrorMessage = !isNullOrUndefined(this.authoringContentData && this.authoringContentData.manageLineRestore &&
            this.authoringContentData.manageLineRestore.serverErrorTxt) ? this.authoringContentData.manageLineRestore.serverErrorTxt : '';
          if (!isNullOrUndefined(this.subscriberStatusSucces) && !isNullOrUndefined(this.uploadJsonData) &&
            this.uploadJsonData.length === this.subscriberStatusSucces) {
            this.restoreBulkLines();
          }
        });
    }
  }
  subscriberStatusResponse(line, subscriberStatusRes) {
    this.subscriberStatusSucces++;
    if (!isNullOrUndefined(subscriberStatusRes) && !isNullOrUndefined(subscriberStatusRes.statusReasonCode)
      && !isNullOrUndefined(subscriberStatusRes.code) && subscriberStatusRes.code === MANAGE_LINE_CONST.SUCCESS) {
      line.reasonCode = subscriberStatusRes.statusReasonCode;
      line.showErrorMessage = '';
    } else {
      line.showErrorMessage = !isNullOrUndefined(this.authoringContentData && this.authoringContentData.manageLineRestore &&
        this.authoringContentData.manageLineRestore.serverErrorTxt) ? this.authoringContentData.manageLineRestore.serverErrorTxt : '';
    }

    if (!isNullOrUndefined(this.subscriberStatusSucces) && !isNullOrUndefined(this.uploadJsonData) &&
      this.uploadJsonData.length === this.subscriberStatusSucces) {
      this.restoreBulkLines();
    }
  }
  restoreBulkLines(): void {
    const bulkRestoreRequestPayload = new BulkRequestsForRestore();
    bulkRestoreRequestPayload.targetServiceName = MANAGE_LINE_CONST.RESTORE_SERVICE;
    bulkRestoreRequestPayload.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
    this.logonData = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
      this.restoreLines?.forEach((element) => {
          const bulkJsonData = new RequestsBulkLine();
          bulkJsonData.orgId = this.orgId
          bulkJsonData.msisdn = element.PhoneNumber;
          bulkJsonData.reasonCode = element.reasonCode ;
          const year1 = new Date(element?.RestoreDate)?.getFullYear();
          const month1 = Number(new Date(element?.RestoreDate)?.getMonth());
          const day1 = new Date(element?.RestoreDate)?.getDate();
          bulkJsonData.restoreDate = (element.RestoreDate !== '') ? (this.datePipe.transform(new Date(year1, month1, day1), MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL)) : '';
          bulkJsonData.logonId = this.logonData?.logonID || COMMON_CONSTANTS.LOGON_ID;
          bulkJsonData.email =  this.logonData?.logonEmail || COMMON_CONSTANTS.LOGON_ID;
          bulkJsonData.dealerCode = this.logonData?.dealerCode ;
          bulkJsonData.validatorType = element.approverType ;

          if (element.RestoreDate !== '' || (!isNullOrUndefined(element.RestoreDate)))
            bulkRestoreRequestPayload.requests.push(bulkJsonData);

      });
      if (bulkRestoreRequestPayload && this.restoreLines) {
        this.manageLineService.bulkServiceRestore(bulkRestoreRequestPayload).subscribe((restoreLineResponse) => {
          if (restoreLineResponse.token && restoreLineResponse.status === MANAGE_LINE_CONST.SUCCESS) {
            this.manageLineService.close();
            this.restoreErrorMsg = '';
            const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
              successModalRef.componentInstance.token = restoreLineResponse.token;
              successModalRef.componentInstance.bulkRestoreData = bulkRestoreRequestPayload;
              successModalRef.componentInstance.bulkUploadFlow = true;
              successModalRef.componentInstance.flowType = BULK_UPLOAD.RESTORE_KEY;
              successModalRef.componentInstance.header = this.authoringContentData.manageLineRestore.restoredRequestComplete;
          } else {
            this.restoreErrorMsg =  this.authoringContentData.manageLineRestore.bulkApiFailMsgTxt;
          }
          this._loaderSvc.stop();
        }, (error) => {
          this.restoreErrorMsg =  this.authoringContentData.manageLineRestore.bulkApiFailMsgTxt;
          this.utilsSvc.errorHandling(error);
          this._loaderSvc.stop();
        });
      }
  }

  checkingSimSwapDataValidation() {
    this.linesWithError = [];
    this.restoreLines = [];
    this.reasons = simChangeReason;
    this.uploadJsonData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);
    if (!isNullOrUndefined(this.uploadJsonData)) {
      this.iterateUploadJsonData();
      if (this.linesWithError.length === 0) {
        this.blkUpldSubmittitle = this.restoreLines.length + this.authoringContentData.bulkFlow.itemLoaded;
        this.itemLoadedSuccfully = this.restoreLines.length + this.authoringContentData.bulkFlow.itemLoadedSuccessfully;
      }
      this.simswapUpdateCountAndCheckbox();
    }
  }
  iterateUploadJsonData(){
    for (const line of this.uploadJsonData) {
      if(this.eSimEnabled){
        this.iterateUploadJsonDataEsimEnabled(line);
      }else{
        this.iterateUploadJsonDataEsimNotEnabled(line);
      }
    }
  }
  validateReasonForSimSwap(value) {
    return _.find(SIM_SWAP_REASONS, { description: value });
  }
  iterateUploadJsonDataEsimEnabled(line){
    /** Scenarios to show accordion in bulk simswap modal:
     * Reason_for_change value is invalid
     * EID and newSim are not empty
     * EID and newSim are empty
     * EID and newSim are not matching its regex
     * Reason_for_change is empty
     * EID is empty and (oldSim == newSim) **/
    if (this.validateReasonForSimSwap(line.Reason_For_Change) === undefined ||
      (line[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] === '' && line[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] === '')
    || (line[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt]  !== '' && line[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] !== '')
      || (!this.regex19.test(line[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] ) && !this.regex20.test(line[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] ) && !this.regex32.test(line[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt]))
    || (line[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] === '' && line.OldSim === line[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt])
    || (line.Reason_For_Change === '')) {
      this.errorLines(line);
    } else {
      this.restoreLines.push(line);
    }
  }
  errorLines(line){
    if (line[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] === '' && line.OldSim === line[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt]) {
      line[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt]  = '';
    }
    if (line.PhoneNumber === '') {
      line.PhoneNumber = '- -';
    }
    if (this.validateReasonForSimSwap(line.Reason_For_Change) === undefined) {
      line.Reason_For_Change = '';
    }
    this.linesWithError.push(line);
    this.linesWithErrorDuplicate.length = this.linesWithError.length;
  }
  iterateUploadJsonDataEsimNotEnabled(line){
    if (isNullOrUndefined(line.NewSim) || (!SIM_CHANGE_CONST.REGEX19.test(line.NewSim) && !SIM_CHANGE_CONST.REGEX20.test(line.NewSim)) || (line.OldSim === line.NewSim) || (line.Reason_For_Change === '')) {
      if (line.OldSim === line.NewSim) {
        line.NewSim = '';
      }
      if (line.PhoneNumber === '') {
        line.PhoneNumber = COMMON_CONSTANTS.DOUBLE_SPACE_HYPHEN;
      }
      this.linesWithError.push(line);
      this.linesWithErrorDuplicate.length = this.linesWithError.length;
    } else {
      this.restoreLines.push(line);
    }
  }
  simswapUpdateCountAndCheckbox(){
    if (!isNullOrUndefined(this.linesWithError) && this.linesWithError.length > 0) {
      this.manageLineService.step = 0;
      this.validationError = true;
      this.reviewMsg = this.authoringContentData.changeSim.bulkReviewTxt;
      this.itemLoadedSuccfully = this.restoreLines.length + this.authoringContentData.changeSim.bulkItemLoadedSuccesTxt;
      if (this.linesWithError.length > 1) {
        this.blkUpldSubmittitle = this.restoreLines.length + this.authoringContentData.changeSim.itemLoadedComma + this.linesWithError.length
        + this.authoringContentData.bulkFlow.bulkInlineflowIssuesTxt;
        this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.bulkFlow.bulkInlineflowIssuesTxt;
      } else {
        this.blkUpldSubmittitle = this.restoreLines.length + this.authoringContentData.changeSim.itemLoadedComma + this.linesWithError.length + this.authoringContentData.changeSim.bulkIssueFoundTxt;
        this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.changeSim.bulkIssueFoundTxt;
      }
    }
    if (!isNullOrUndefined(this.restoreLines) && this.restoreLines.length === 0) {
      this.termsAndConditionCheckBox = true;
    } else {
      this.termsAndConditionCheckBox = false;
    }
  }
  downloadSuspendValidatedData() {
    this.uploadJsonData = _.filter(this.suspendendeLines, { succesValidator: true as any });
    let temp;
    if (!isNullOrUndefined(this.uploadJsonData)) {
      const suspendTemplate = [];
      for (const jsonData of this.uploadJsonData) {
        const line = jsonData;
        if (line) {
          if ((isNullOrUndefined(line.validatorType) || line.validatorType === '') && (line.reasonCode !== MANAGE_LINE_CONST.ELST && line.reasonCode !== MANAGE_LINE_CONST.SSQ && line.reasonCode !== SUSPEND_CONSTANTS.RETENTION_SUSPEND)) {
            line.validatorType = line.approverType.description;
          }
          temp = {};
          temp = this.suspendTemplateArray(temp,line);
          suspendTemplate.push(temp);
        }
      }
      this.exportSvc.exportAsExcelFile(suspendTemplate, BULK_UPLOAD.SUSPEND_SUCCESS_DOWNLOAD);
    }
  }
  suspendTemplateArray(temp,line){
    temp[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] = !isNullOrUndefined(line.msisdn) ? Number(line.msisdn) : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] = !isNullOrUndefined(line.reasonCode) ? this.getSuspendReasonCode(line.reasonCode) : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_APPROVER_TXT] = !isNullOrUndefined(line.validatorType) && line.reasonCode !== MANAGE_LINE_CONST.SSQ && line.reasonCode !== MANAGE_LINE_CONST.ELST && line.reasonCode !== SUSPEND_CONSTANTS.RETENTION_SUSPEND ? line.validatorType : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_STARTDATE_TXT] = !isNullOrUndefined(line.suspendStartDate) && line.reasonCode !== MANAGE_LINE_CONST.ELST && line.reasonCode !== SUSPEND_CONSTANTS.RETENTION_SUSPEND ? this.transformDate(line.suspendStartDate) : '';
    temp[BULK_UPLOAD.BULK_SUSPEND_ENDDATE_TXT] = !isNullOrUndefined(line.restoreDate) && line.reasonCode !== MANAGE_LINE_CONST.ELST && line.reasonCode !== SUSPEND_CONSTANTS.RETENTION_SUSPEND ? this.transformDate(line.restoreDate) : '';
    return temp;
  }
  transformDate(date: string) {
    if (!isNullOrUndefined(date)) {
      const splitDate = date.split(COMMON_CONSTANTS.SYMBOLS.DASH);
      return splitDate.length === VALUE.THREE ? splitDate[VALUE.ONE] +
        COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH + splitDate[VALUE.TWO] + COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH +
        splitDate[VALUE.ZERO] : date;
    } else {
      return '';
    }
  }
  getSuspendReasonCode(reasonCode) {
    switch (reasonCode) {
      case SUSPEND_CONSTANTS.TEMP_SUSPEND:
        return SUSPEND_CONSTANTS.TEMP_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES:
        return SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES_TXT;
      case SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES:
        return SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES_TXT;
      case SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND:
        return SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.SEASONAL_SUSPEND:
        return SUSPEND_CONSTANTS.SEASONAL_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.MILTARY_SUSPEND:
        return SUSPEND_CONSTANTS.MILTARY_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND:
        return SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND:
        return SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND:
        return SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.SUNC_SUSPEND:
        return SUSPEND_CONSTANTS.SUNC_SUSPEND_TXT;
      case SUSPEND_CONSTANTS.RETENTION_SUSPEND:
        return SUSPEND_CONSTANTS.RETENTION_SUSPEND_TXT;
    }
  }
  removeDuplicateFromArray(event){
    const duplicateIndex = this.restoreLines.findIndex((item) => item.msisdn === event.msisdn);
    if (duplicateIndex > -1) {
      this.restoreLines.splice(this.restoreLines.indexOf(duplicateIndex), 1);
    }
  }
  visibleNextButton(event: any) {
    if (event && this.restoreLines != null) {
      const nextIndex = this.linesWithError.findIndex((item) => item.PhoneNumber === event.msisdn);
      if (this.regex19.test(event.newSim) || this.regex20.test(event.newSim)
      || (this.eSimEnabled && this.regex32.test(event.eid))) {
        this.linesWithError[nextIndex].success = true;
       this.removeDuplicateFromArray(event);
       this.restoreLines.push(event);
      } else {
        this.linesWithError[nextIndex].success = false;
        if (this.restoreLines.indexOf(event) > -1) {
          this.restoreLines.splice(this.restoreLines.indexOf(event), 1);
        }
      }

      this.linesWithErrorDuplicate.length = (this.uploadJsonData.length - this.restoreLines.length);
      this.itmeNotLoadeSuccefully = (this.uploadJsonData.length - this.restoreLines.length) + this.authoringContentData.changeSim.bulkIssueFoundTxt;
      this.itemLoadedSuccfully = this.restoreLines.length + this.authoringContentData.changeSim.bulkItemLoadedSuccesTxt;
      if (this.linesWithErrorDuplicate.length > 0) {
        this.blkUpldSubmittitle = this.restoreLines.length
          + this.authoringContentData.bulkFlow.itemsLoadedTxt + ', '
          + (this.uploadJsonData.length - this.restoreLines.length) + this.authoringContentData.bulkFlow.bulkInlineflowIssuesTxt;
      } else {
        this.blkUpldSubmittitle = this.restoreLines.length + this.authoringContentData.bulkFlow.itemsLoadedTxt;
      }
      this.termsAndConditionCheckBox = this.restoreLines.length === 0;
    }
  }

  validateChangeReason(line) {

    line.validated = !_.isEmpty(line.Preferred_Area_Code);
    line.success = line.validated;
    line.errorValidator = !line.validated;
  }

  validateZipcode(line, event) {


    if (event.target.value.length === COMMON_CONSTANTS.DIGITS.THREE && !_.isEmpty(line.Reason_For_Change)) {
      line.invalid_area_code = false;
      line.validated = true;
      line.success = line.validated;
      line.errorValidator = !line.validated;
      line.Preferred_Area_Code = event.target.value;
      const index = _.findIndex(this.linesWithError, (items: any) => {
        return items.PhoneNumber === line.PhoneNumber;
      });
      if (index > COMMON_CONSTANTS.DIGITS.MINUS_ONE) {
        this.validChangeNumberLines.push(line);
        this.linesWithError.splice(index, 1);
        this.bulkUploadFailedFlag = this.linesWithError.length > 0;
      }
    } else {
      line.invalid_area_code = true;
      line.validated = false;
      line.success = line.validated;
      line.errorValidator = !line.validated;
      const index = _.findIndex(this.validChangeNumberLines, (items: any) => {
        return items.PhoneNumber === line.PhoneNumber;
      });
      if (index > COMMON_CONSTANTS.DIGITS.MINUS_ONE) {
        this.linesWithError.push(line);
        this.validChangeNumberLines.splice(index, 1);
        this.bulkUploadFailedFlag = this.linesWithError.length > 0;
      }
    }

  }
  getErrorMessage() {
    return (this.changeReasonForm.hasError(('required') ? this.authoringContentData.changeSim.mustEnterValue : ''))
      || (this.changeAreaCodeForm.hasError(('required') ? this.authoringContentData.changeSim.mustEnterValue : ''));
  }

  findDaysDifference(startDate: string, endDate: string) {


    const formattedStartDate = new Date(startDate);
    const formattedEndDate = new Date(endDate);
    // tslint:disable-next-line: radix
    const date1_unixtime = parseInt((formattedStartDate.getTime() / VALUE.THOUSAND).toString());
    // tslint:disable-next-line: radix
    const date2_unixtime = parseInt((formattedEndDate.getTime() / VALUE.THOUSAND).toString());
    const timeDifference = date2_unixtime - date1_unixtime;
    const timeDifferenceInHours = timeDifference / VALUE.SIXTY / VALUE.SIXTY;
    return timeDifferenceInHours / VALUE.TWENTY_FOUR;
  }

  // suspend flow code
  checkingSuspendDataValidation() {
    this.uploadJsonData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY).requests;
    ContentService.CleanCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);
    for (const line of this.uploadJsonData) {
      if ((this.isDateSmallerThanToday(line.suspendStartDate) || (this.findDaysDifference(line.suspendStartDate, line.restoreDate) < COMMON_CONSTANTS.DIGITS.ZERO)) && line.reasonCode !== SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND && line.reasonCode !== SUSPEND_CONSTANTS.RETENTION_SUSPEND) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = !isNullOrUndefined(this.authoringContentData.bulkFlow) && !isNullOrUndefined(this.authoringContentData.bulkFlow.startDateErrTxt) ?
          this.authoringContentData.bulkFlow.startDateErrTxt : '';
        this.linesWithError.push(line);
      } else {
        // this.datesShouldGreaterThanCurrentDate(line);
        // tslint:disable-next-line: max-line-length
        if (!isNullOrUndefined(line.msisdn) && line.msisdn !== '' && !isNullOrUndefined(line.reasonCode) && line.reasonCode !== '') {
          this.suspendReasonCode(line);
        } else {
          line.succesValidator = false;
          line.errorValidator = true;
          line.errorMsg = this.authoringContentData.bulkFlow.errMsgSuspendReason;
          this.linesWithError.push(line);
        }
      }
    }
    this.suspendUpdateCountAndCheckbox();
  }
  temporarySuspendFlow(line){
    const daysDifference = this.findDaysDifference(line.suspendStartDate, line.restoreDate);
    const validatorType = line.validatorType.toUpperCase();
    switch (validatorType) {
      case SUSPEND_CONSTANTS.SENIOR_MANAGER:
        this.validatorTypeSeniorManager(daysDifference, line);
        break;
      case SUSPEND_CONSTANTS.DIRECTOR_AND_VP:
        this.validatorThirtyDays(daysDifference, line);
        break;
      case SUSPEND_CONSTANTS.SALES_VP_AND_QA_TEAM:
        this.validatorNinetyDays(daysDifference, line);
        break;
    }
  }
  edusSuspendFlow(line){
    const daysDifference = this.findDaysDifference(line.suspendStartDate, line.restoreDate);
    this.validatorSixtyDays(daysDifference, line);
  }

  imsSuspendFlow(line){
    const daysDifference = this.findDaysDifference(line.suspendStartDate, line.restoreDate);
    this.validatorThirtyDays(daysDifference, line);
  }

  mcsaContractualSuspendFlow(line){
    const daysDifference = this.findDaysDifference(line.suspendStartDate, line.restoreDate);
    if (daysDifference <= COMMON_CONSTANTS.DIGITS.NINTY) {
      line.succesValidator = true;
      this.suspendendeLines.push(line);
    } else {
      line.errorMsg = this.authoringContentData?.bulkFlow?.errMsgNinetyDays ? this.authoringContentData.bulkFlow.errMsgNinetyDays : '';
      line.errorValidator = true;
      line.succesValidator = false;
      this.linesWithError.push(line);
    }
  }
  suncSuspendFlow(line){
    if (line.restoreDate == '') {
      line.succesValidator = true;
      this.suspendendeLines.push(line);
    } else if (line.restoreDate != ''){
    const daysDifference = this.findDaysDifference(line.suspendStartDate, line.restoreDate);
    if (daysDifference <= COMMON_CONSTANTS.DIGITS.ONE_HUNDRED_YEARS_IN_DAYS) {
      line.succesValidator = true;
      this.suspendendeLines.push(line);
    } else {
      line.errorMsg = this.authoringContentData?.bulkFlow?.errMsgOneHundredYears ? this.authoringContentData.bulkFlow.errMsgOneHundredYears : '';
      line.errorValidator = true;
      line.succesValidator = false;
      this.linesWithError.push(line);
    }
  }
  }
  validatorTypeSeniorManager(daysDifference,line){
    if (daysDifference <= COMMON_CONSTANTS.DIGITS.FOURTEEN) {
      line.succesValidator = true;
      this.suspendendeLines.push(line);
    } else {
      line.errorMsg = !isNullOrUndefined(this.authoringContentData.bulkFlow) && !isNullOrUndefined(this.authoringContentData.bulkFlow.errMsgTenDays) ?
        this.authoringContentData.bulkFlow.errMsgTenDays : '';
      line.errorValidator = true;
      line.succesValidator = false;
      this.linesWithError.push(line);
    }
  }
  validatorThirtyDays(daysDifference,line){
    if (daysDifference <= COMMON_CONSTANTS.DIGITS.THIRTY) {
      line.succesValidator = true;
      this.suspendendeLines.push(line);
    } else {
      line.errorMsg = !isNullOrUndefined(this.authoringContentData.bulkFlow) && !isNullOrUndefined(this.authoringContentData.bulkFlow.errMsgThirtyDays) ?
        this.authoringContentData.bulkFlow.errMsgThirtyDays : '';
      line.errorValidator = true;
      line.succesValidator = false;
      this.linesWithError.push(line);
    }
  }
  suspendWithoutChargesFlow(line){
    const daysDifference = this.findDaysDifference(line.suspendStartDate, line.restoreDate);
    const validatorType = line.validatorType.toUpperCase();
    switch (validatorType) {
      case SUSPEND_CONSTANTS.SALES_REP_INITIATED:
        this.validatorThirtyDays(daysDifference, line);
        break;
      case SUSPEND_CONSTANTS.B2B_MARKETING_MANAGER:
      case SUSPEND_CONSTANTS.SALES_DIRECTOR:
      case SUSPEND_CONSTANTS.CUSTOMER_INITIATED:
        this.validatorSixtyDays(daysDifference, line);
        break;
      case SUSPEND_CONSTANTS.VP:
        this.validatorNinetyDays(daysDifference, line);
        break;
     }
  }

  validatorSixtyDays(daysDifference,line){
    if (daysDifference <= COMMON_CONSTANTS.DIGITS.SIXTY) {
      line.succesValidator = true;
      this.suspendendeLines.push(line);
    } else {
      line.errorMsg = this.authoringContentData?.bulkFlow?.errMsgSixtyDays ?
this.authoringContentData.bulkFlow.errMsgSixtyDays : '';
      line.succesValidator = false;
      line.errorValidator = true;
      this.linesWithError.push(line);
    }
  }
  validatorNinetyDays(daysDifference,line){
    if (daysDifference <= COMMON_CONSTANTS.DIGITS.NINTY) {
      line.succesValidator = true;
      this.suspendendeLines.push(line);
    } else {
      line.errorMsg = this.authoringContentData?.bulkFlow?.errMsgNinetyDays ?
this.authoringContentData.bulkFlow.errMsgNinetyDays : '';
      line.errorValidator = true;
      line.succesValidator = false;
      this.linesWithError.push(line);
    }
  }
  seasonalSuspendFlow(line){
    const daysDifference = this.findDaysDifference(line.suspendStartDate, line.restoreDate);
    line.isSeasonal = true;
    this.validatorNinetyDays(daysDifference, line);
  }
  suspendReasonCode(line){
   if (line.reasonCode === SUSPEND_CONSTANTS.SEASONAL_SUSPEND && line.suspendStartDate && line.restoreDate) {
      this.seasonalSuspendFlow(line);
      return;
    } else if (line.reasonCode === SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND) {
      line.succesValidator = true;
      line.isstolen = true;
      this.suspendendeLines.push(line);
      return;
    } else if (line.reasonCode === SUSPEND_CONSTANTS.SUNC_SUSPEND && line.validatorType && line.suspendStartDate) {
      this.suncSuspendFlow(line);
      return;
    } else if (line.reasonCode === SUSPEND_CONSTANTS.RETENTION_SUSPEND) {
      line.successValidator = true;
      line.isstolen = true;
      this.suspendendeLines.push(line);
      return;
    } else if (line.validatorType && line.suspendStartDate && line.restoreDate) {
      switch (line.reasonCode) {
        case SUSPEND_CONSTANTS.TEMP_SUSPEND:
          this.temporarySuspendFlow(line);
          return;
        case SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND:
          this.edusSuspendFlow(line);
          return;
        case SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND:
          this.imsSuspendFlow(line);
          return;
        case SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND:
          this.mcsaContractualSuspendFlow(line);
          return;
        case SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES:
        case SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES:
          this.suspendWithoutChargesFlow(line);
          return;
      }
    }
    line.succesValidator = false;
    line.errorValidator = true;
    this.linesWithError.push(line);
    let errMsgCombined = [];
    this.addLineErrorMessages(line, errMsgCombined);
  }

  addLineErrorMessages(line : any, errMsgCombined : any){
    if (!line.validatorType && this.authoringContentData?.bulkFlow?.errMsgSuspendReason) {
      errMsgCombined.push(this.authoringContentData.bulkFlow.errMsgSuspendReason);
    }
    if (!line.suspendStartDate && this.authoringContentData?.bulkFlow?.startDateErrTxt) {
      errMsgCombined.push(this.authoringContentData.bulkFlow.startDateErrTxt);
    }
    if (!line.restoreDate && this.authoringContentData?.bulkFlow?.endDateErrTxt) {
      errMsgCombined.push(this.authoringContentData.bulkFlow.endDateErrTxt);
    }
    line.errorMsg = (errMsgCombined.length > 0) ? errMsgCombined.join(' ') : '';
  }
  
  suspendUpdateCountAndCheckbox(){
    if (!isNullOrUndefined(this.linesWithError) && this.linesWithError.length > 0) {
      const currentDate = new Date();
      this.minimumDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
      this.linesWithErrorDuplicate = this.linesWithError.map((x) => Object.assign({}, x));
      this.validationError = true;
      this.blkUpldSubmittitle = this.suspendendeLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.suspendendeLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.expansionPanelOpened(this.linesWithError[0]);
      this.getSuspendedReasons();
    }

    if (!isNullOrUndefined(this.suspendendeLines) && this.suspendendeLines.length > 0 && this.linesWithError.length == 0) {
      this.blkUpldSubmittitle = this.suspendendeLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.suspendendeLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
    }

    if (!isNullOrUndefined(this.suspendendeLines) && this.suspendendeLines.length === 0) {
      this.termsAndConditionCheckBox = true;
    } else {
      this.termsAndConditionCheckBox = false;
    }
  }
  changeApproverTypeForMultiple(line: any, approverType: any) {
    line.errorMsg = null;
    line.approverType = approverType;
    line.lineApproverType = new UntypedFormControl(approverType.description);

  }

  isDateSmallerThanToday(incomingDate) {
    if (!isNullOrUndefined(incomingDate) && incomingDate !== '') {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      incomingDate = new Date(incomingDate);
      if (incomingDate.getTime() < currentDate.getTime()) {
        return true;
      } else {
        return false;
      }
    }
  }

  isDateTodayOrLater(incomingDate) {
    if (!isNullOrUndefined(incomingDate) && incomingDate !== '') {
      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      incomingDate = new Date(incomingDate);

      if (incomingDate.getTime() >= currentDate.getTime()) {
        return true;
      } else {
        return false;
      }
    }
  }

  settingDateSuspend(arraySplit) {
    if (!isNullOrUndefined(arraySplit)) {
      return this.datePipe.transform(new Date(Number(arraySplit[2]), Number(arraySplit[0]) - COMMON_CONSTANTS.DIGITS.ONE, Number(arraySplit[1])),
        MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    } else {
      return null;
    }
  }

  settingFlagEndDate(line) {
    line.errorValidator = true;
    line.restoreDateValidation = true;
    return false;
  }

  settingFlagStartDate(line) {
    line.errorValidator = true;
    line.suspendStartDateValidation = true;
    return false;
  }

  settingMiniumDateForEndDate(line) {
    const newdate = this.datePipe.transform(new Date(line.startDate.year, line.startDate.month - COMMON_CONSTANTS.DIGITS.ONE, line.startDate.day + COMMON_CONSTANTS.DIGITS.ONE),
      MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    line.minimumEndDate = {
      year: Number(newdate.split('-')[0]), month: Number(newdate.split('-')[1]),
      day: Number(newdate.split('-')[2]),
    };
  }

  getSuspendedReasons() {

    this.manageLineService.suspendReasons().subscribe((reasons) => {
      if (!isNullOrUndefined(reasons)) {
        this.resonErrorInline = '';
        this.reasons = reasons.suspendReasons;
        const index = this.reasons.findIndex((item) => item.code === MANAGE_LINE_CONST.MSS);
        if (!isNullOrUndefined(index) && index > COMMON_CONSTANTS.DIGITS.MINUS_ONE) {
          this.reasons.splice(index, COMMON_CONSTANTS.DIGITS.ONE);
        }
        this.setReasonsAccordingToFile();
      } else {
        this.resonErrorInline = COMMON_CONSTANTS.SERVER_ERROR_MESSAGE;
      }
    }, (err) => {
      this.resonErrorInline = !isNullOrUndefined(err.message) ? err.message : COMMON_CONSTANTS.SERVER_ERROR_MESSAGE;
    });
  }

  setReasonsAccordingToFile() {
    this.linesWithError.forEach((element) => {
      if (!isNullOrUndefined(element && element.reasonCode)) {
        this.reasons.forEach((reason) => {
          if (reason.code === element.reasonCode) {
            element.reasonForChange = new UntypedFormControl(reason.description);
            this.onChangeReasonForMultiple(element, reason);
          }
        });
      }
    });
  }

  onChangeCancelSubscriberReasonForMultiple(line, reason) {
    line.Cancel_reason = reason;
  }

  // on change of reason pop on accordian
  onChangeSuspendReasonForMultiple(line, reason) {
    line.restoreDateValidation = false;
    line.reasoneCodeValidation = false;
    line.suspendStartDateValidation = false;
    line.startDate = null;
    line.endDate = '';
    line.succesValidator = false;
    line.errorValidator = true;
    if (reason.code === MANAGE_LINE_CONST.SSQ) {
      line.isSeasonal = true;
      line.isstolen = false;
      this.settingReasonModal(line, reason);
    } else if (reason.code === SUSPEND_CONSTANTS.LOST_STOLEN_SUSPEND) {
      line.isSeasonal = false;
      line.isstolen = true;
      this.multipleEndDateSelected(line);
      this.settingReasonModal(line, reason);
    } else if (reason.code === SUSPEND_CONSTANTS.RETENTION_SUSPEND) {
      line.isSeasonal = false;
      line.isstolen = false;
      this.multipleEndDateSelected(line);
      this.settingReasonModal(line, reason);
    } else {
      line.isSeasonal = false;
      line.isstolen = false;
      this.onChangeReasonForMultiple(line, reason);
    }
    this.suspendCheckingMaxDateValidation(line);
    this.checkingMaxDate(line);
  }

  settingReasonModal(line, reason) {
    line.reasonForChange = new UntypedFormControl(reason.description);
    line.reasonForChanges = reason;
    line.reasonCode = reason.code;
  }

  onChangeReasonForMultiple(line, reason) {
    this.selectsubmitCheckBox = false;
    this.settingReasonModal(line, reason);
    this.manageLineService.suspendApprovalTypes(reason.code).subscribe((approvalTypes) => {
      if (!isNullOrUndefined(approvalTypes)) {
        this.approverTypeList = approvalTypes.approverTypes;
        line.approverTypeList = approvalTypes.approverTypes;
        if (!isNullOrUndefined(line && line.validatorType)) {
          this.settingApproverTypeAccordingTOFile(line);
        } else {
          line.approverType = line.approverTypeList[0];
          line.lineApproverType = new UntypedFormControl(line.approverTypeList[0].description);
          if (isNullOrUndefined(line.startDate) || isNullOrUndefined(line.endDate)) {
            line.succesValidator = false;
            line.errorValidator = false;
          }
        }
        this.suspendCheckingMaxDateValidation(line);
      }
      if (reason.code === 'SSQ') {
        this.onChangeSuspendReasonForMultiple(line, reason);
      }
    });
  }

  settingApproverTypeAccordingTOFile(line) {
    if (!isNullOrUndefined(this.approverTypeList && line)) {
      let flag = true;
      this.approverTypeList.forEach((element) => {
        if (line.validatorType === element.code || line.validatorType === element.description) {
          flag = false;
          line.lineApproverType = new UntypedFormControl(element.description);
          line.approverType = element;
        }
      });
      if (flag && line.reasonCode !== SUSPEND_CONSTANTS.SEASONAL_SUSPEND) {
        line.approverType = line.approverTypeList[0];
        line.lineApproverType = new UntypedFormControl(line.approverTypeList[0].description);
      }
    }
  }

  multipleStartDateSelected(line) {
    line.endDate = '';

    line.suspendStartDateValidation = false;
    line.restoreDateValidation = false;
    this.settingMiniumDateForEndDate(line);
    line.suspendStartDate = this.datePipe.transform(new Date(line.startDate.year,
      line.startDate.month - COMMON_CONSTANTS.DIGITS.ONE, line.startDate.day), MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    this.suspendCheckingMaxDateValidation(line);
  }

  checkingMaxDate(line) {
    if (line.reasonCode === SUSPEND_CONSTANTS.SUSPEND_WITHOUT_CHARGES ||
      line.reasonCode === SUSPEND_CONSTANTS.SUSPEND_WITH_CHARGES) {
      const currentDate = new Date();
      line.maxStartDate = {
        year: currentDate.getFullYear() + COMMON_CONSTANTS.DIGITS.ONE, month: currentDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
        day: currentDate.getDate(),
      };
    } else {
      line.maxStartDate = undefined;
    }
  }

  suspendCheckingMaxDateValidation(line) {
    let dtStartDate = new Date();
    if (!line.startDate) {
      line.startDate = {
        year: dtStartDate.getFullYear(), month: dtStartDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
        day: dtStartDate.getDate(),
      };
    }
    if (line.suspendStartDate) {
      dtStartDate = new Date(line.suspendStartDate);
      line.startDate = {
        year: dtStartDate.getFullYear(), month: dtStartDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
        day: dtStartDate.getDate(),
      };
    } else {
      this.dateTransform(line);
    }
    if (dtStartDate < new Date()) {
      dtStartDate = new Date();
    }
    line.startDate = {
      year: dtStartDate.getFullYear(), month: dtStartDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE,
      day: dtStartDate.getDate(),
    };
    let currentDate: Date = new Date(line.startDate.year, line.startDate.month - COMMON_CONSTANTS.DIGITS.ONE, line.startDate.day);
    let logicalDate: any;
    line.minimumEndDate = {
      year: line.startDate.year, month: line.startDate.month,
      day: line.startDate.day + COMMON_CONSTANTS.DIGITS.ONE,
    };
    if (line.approverType?.code) {
      switch (line.reasonForChanges.code) {
        case SUSPEND_CONSTANTS.SEASONAL_SUSPEND:
          logicalDate = new Date(currentDate.setDate(currentDate.getDate() + VALUE.NINETY));
          line.maxDate = {
            year: logicalDate.getFullYear(), month: logicalDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE, day: logicalDate.getDate(),
          };
          break;
        case SUSPEND_CONSTANTS.EDUCATION_SUMMER_SUSPEND:
          logicalDate = new Date(currentDate.setDate(currentDate.getDate() + VALUE.SIXTY));
          line.maxDate = {
            year: logicalDate.getFullYear(), month: logicalDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE, day: logicalDate.getDate(),
          };
          break;
        case SUSPEND_CONSTANTS.IMPLEMENTATION_SUSPEND:
          logicalDate = new Date(currentDate.setDate(currentDate.getDate() + VALUE.THIRTY));
          line.maxDate = {
            year: logicalDate.getFullYear(), month: logicalDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE, day: logicalDate.getDate(),
          };
          break;
        case SUSPEND_CONSTANTS.MCSA_CONTRACTUAL_SUSPEND:
          logicalDate = new Date(currentDate.setDate(currentDate.getDate() + COMMON_CONSTANTS.DIGITS.NINTY));
          line.maxDate = {
            year: logicalDate.getFullYear(), month: logicalDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE, day: logicalDate.getDate(),
          };
          break;
        case SUSPEND_CONSTANTS.SUNC_SUSPEND:
          logicalDate = new Date(currentDate.setDate(currentDate.getDate() + COMMON_CONSTANTS.DIGITS.ONE_HUNDRED_YEARS_IN_DAYS));
          line.maxDate = {
            year: logicalDate.getFullYear(), month: logicalDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE, day: logicalDate.getDate(),
          };
          break;
      default:
          switch (line.approverType.code) {
            case SUSPEND_CONSTANTS.APPROVER_TYPES.SALES_REP_INITIATED:
            case SUSPEND_CONSTANTS.APPROVER_TYPES.DIRECTOR:
              logicalDate = new Date(currentDate.setDate(currentDate.getDate() + VALUE.THIRTY));
              line.maxDate = {
                year: logicalDate.getFullYear(), month: logicalDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE, day: logicalDate.getDate(),
              };
              break;
            case SUSPEND_CONSTANTS.APPROVER_TYPES.B2B_MARKETING_MANAGER:
            case SUSPEND_CONSTANTS.APPROVER_TYPES.SALES_DIRECTOR:
            case SUSPEND_CONSTANTS.APPROVER_TYPES.CUSTOMER_INITIATED:
              logicalDate = new Date(currentDate.setDate(currentDate.getDate() + VALUE.SIXTY));
              line.maxDate = {
                year: logicalDate.getFullYear(), month: logicalDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE, day: logicalDate.getDate(),
              };
              break;
            case SUSPEND_CONSTANTS.APPROVER_TYPES.VP:
              logicalDate = new Date(currentDate.setDate(currentDate.getDate() + VALUE.NINETY));
              line.maxDate = {
                year: logicalDate.getFullYear(), month: logicalDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE, day: logicalDate.getDate(),
              };
              break;
            case SUSPEND_CONSTANTS.APPROVER_TYPES.SR_MANAGER:
              logicalDate = new Date(currentDate.setDate(currentDate.getDate() + VALUE.TEN));
              line.maxDate = {
                year: logicalDate.getFullYear(), month: logicalDate.getMonth() + COMMON_CONSTANTS.DIGITS.ONE, day: logicalDate.getDate(),
              };
              break;
          }
      }
    }
  }

  dateTransform(line){
    if (new Date(line.startDate.year, line.startDate.month - COMMON_CONSTANTS.DIGITS.ONE, line.startDate.day) < new Date()) {
      line.suspendStartDate = this.datePipe.transform(new Date(), MANAGE_MODAL_CONST.DATE_FORMAT_MM_DD_YYYY);
    } else {
      line.suspendStartDate = this.datePipe.transform(new Date(line.startDate.year,
        line.startDate.month - COMMON_CONSTANTS.DIGITS.ONE, line.startDate.day), MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    }
  }

  multipleEndDateSelected(line) {
    if (!isNullOrUndefined(line)) {
      this.fetchRestoreDate(line);
      if (!isNullOrUndefined(this.linesWithErrorDuplicate)) {
        const indexMsisdn = this.linesWithErrorDuplicate.findIndex((item) => item.msisdn === line.msisdn);
        this.checkingIndexValue(indexMsisdn);
      }
      line.succesValidator = true;
      line.errorMsg = '';
      line.errorValidator = false;
      const index = this.suspendendeLines.findIndex((item) => item.msisdn === line.msisdn);
      if (index === -1) {
        this.suspendendeLines.push(line);
      }
      if (!isNullOrUndefined(this.linesWithErrorDuplicate) && this.linesWithErrorDuplicate.length > 0) {
        this.blkUpldSubmittitle = this.suspendendeLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt
          + this.linesWithErrorDuplicate.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
        this.itmeNotLoadeSuccefully = this.linesWithErrorDuplicate.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      } else {
        this.blkUpldSubmittitle = this.suspendendeLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedWithOutTxt;
        this.itmeNotLoadeSuccefully = '';
      }
      this.itemLoadedSuccfully = this.suspendendeLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      line.succesValidator = true;
      line.errorValidator = false;
      line.errorMsg = '';
      line.restoreDateValidation = false;
    }
    this.setTermAndonditions();
  }

  fetchRestoreDate(line: any){
    if (!isNullOrUndefined(line.endDate) && line.endDate !== '') {
      line.restoreDate = this.datePipe.transform(new Date(line.endDate.year,
        line.endDate.month - COMMON_CONSTANTS.DIGITS.ONE, line.endDate.day), MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    } else if (!isNullOrUndefined(line.endDate) && line.endDate == '' && line.reasonCode == MANAGE_LINE_CONST.SUNC){
      line.restoreDate = '';
    }
  }

  setTermAndonditions(){
    if (!isNullOrUndefined(this.suspendendeLines) && this.suspendendeLines.length === 0) {
      this.termsAndConditionCheckBox = true;
    } else {
      this.termsAndConditionCheckBox = false;
    }
  }

  checkingIndexValue(indexMsisdn){
    if (indexMsisdn >= 0) {
      this.linesWithErrorDuplicate.splice(indexMsisdn, 1);
    }
  }

  validatingSuspendDate(line, arraySplit) {
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    const currentDate = new Date().getDate();
    let dateFlag = false;
    if (!isNullOrUndefined(line) && !isNullOrUndefined(arraySplit)) {
      if (!isNullOrUndefined(arraySplit) && arraySplit.length === 3) {
        const totalDays = new Date(Number(arraySplit[2]), Number(arraySplit[0]) - COMMON_CONSTANTS.DIGITS.ONE, 0).getDate();
        if (!isNullOrUndefined(arraySplit[2]) && Number(arraySplit[2]) > currentYear) {
          dateFlag = true;
        } else if (!isNullOrUndefined(arraySplit[2]) && Number(arraySplit[2]) === currentYear &&
          !isNullOrUndefined(arraySplit[0]) && Number(arraySplit[0]) > currentMonth + 1) {
            dateFlag = true;
        } else if (!isNullOrUndefined(arraySplit[2]) && Number(arraySplit[2]) === currentYear &&
          !isNullOrUndefined(arraySplit[0]) && Number(arraySplit[0]) === currentMonth + 1 &&
          !isNullOrUndefined(arraySplit[1]) && Number(arraySplit[1]) >= currentDate && Number(arraySplit[1]) <= totalDays) {
            dateFlag = true;
        } else {
          line.succesValidator = false;
          line.errorValidator = true;
        }
      } else {
        line.succesValidator = false;
        line.errorValidator = true;
      }
    }
    return dateFlag;
  }
  // post Call
  submitSuspendDataAfterUpload() {
    if (this.suspendendeLines.length > 0) {
      this.requestHeaders = this.setRequestHeaders();
      this._loaderSvc.start();
      this.manageLineService.bulkSuspend(this.requestHeaders).subscribe((response) => {
        this._loaderSvc.stop();
        this.isLoaderOn = false;
        if (!isNullOrUndefined(response) && !isNullOrUndefined(response.status)
          && response.status === SUSPEND_CONSTANTS.SUCCESS) {
          this.results = response;
          this.manageLineService.close();
          const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
          successModalRef.componentInstance.token = response.token;
          successModalRef.componentInstance.header = this.authoringContentData.manageLine.suspensdRequestComplete;
          successModalRef.componentInstance.bulkUploadFlow = true;
          successModalRef.componentInstance.bulkSuspendData = this.requestHeaders.requests;
          successModalRef.componentInstance.flowType = BULK_UPLOAD.SUSPEND_KEY;
        } else {
          this.manageLineService.close();
          const err = SUSPEND_CONSTANTS.SUSPEND_ERROR;
          this.utilsSvc.errorHandling(err);
        }
      }, (err) => {
        this.manageLineService.close();
        this.utilsSvc.errorHandling(err);
      });

      let submitCTAName = this.authoringContentData.changeNumberAuthoring.submitChange;
      if(this.bulkUploadFailedFlag || (!isNullOrUndefined(this.linesWithErrorDuplicate) && this.linesWithErrorDuplicate.length > 0 && (this.isRestoreFlow || this.isSimSwapFlow || this.isSuspendFlow ))){
        submitCTAName= this.authoringContentData.changeNumberAuthoring.submitSuccessfulItems;
      }
      this.pdlService.ifEnabledGenerateClickTag({
        type: ANALYTICS.CLICK_TO_ACTION,
        action: ANALYTICS.CLICK,
        ctaName: submitCTAName,
        assetType: ANALYTICS.BUTTON,
        modalName:ANALYTICS.BULK_SUSPEND,
        userSelection:''
      });
    }
  }

  formatDate(date) {
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 101).toString().substring(1);
    const day = (date.getDate() + 100).toString().substring(1);
    return year + "-" + month + "-" + day;
  }

  submitCancelSubscriberDataAfterUpload() {
    this.linesWithErrorDuplicate = []
    if (this.cancelLines.length > 0) {
      const codeReasonMap = this.makeCancelSubscriberReasonCodeMap();
      const orgId = this._helperUtilSvc.getOrgID() || '';
      for (const jsonData of this.cancelLines) {
        this.requests.push({
          "financialAccountNumber": this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN),
          "mobileNumber": jsonData ? jsonData.PhoneNumber : '',
          "reasonCode": codeReasonMap[jsonData.Cancel_reason],
          "activityDate": jsonData.Cancel_date ? this.formatDate(new Date(jsonData.Cancel_date)) : '',
          "logonId": this.logonData ? this.logonData.logonID : '',
          "email": this.logonData ? this.logonData.logonEmail : '',
          "orgId": orgId
        });
      }
      this.requestBody = {
        "targetServiceName": BULK_UPLOAD.CANCEL_SUBSCRIBER,
        "requests": this.requests,
        "ban": this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN)
      };
      this._loaderSvc.start();
      this.isLoaderOn = true;
      this.manageLineService.bulkCancelSubscriberProcessor(this.requestBody).subscribe((response) => {
        this._loaderSvc.stop();
        this.isLoaderOn = false;
        if (!isNullOrUndefined(response) && !isNullOrUndefined(response.status)
          && response.status === MANAGE_LINE_CONST.SUCCESS) {
          this.results = response;
          this.manageLineService.close();
          const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
          successModalRef.componentInstance.token = response.token;
          successModalRef.componentInstance.header = this.authoringContentData.manageLine.cancelSubscriberRequestComplete;
          successModalRef.componentInstance.bulkUploadFlow = true;
          successModalRef.componentInstance.isConfirmationPopup = false;
          successModalRef.componentInstance.isCancelSubscriber = true;
          successModalRef.componentInstance.bulkCancelSubscriberData = this.requestBody.requests;
          successModalRef.componentInstance.flowType = BULK_UPLOAD.CANCEL_SUBSCRIBER;
        } else {
          this.manageLineService.close();
          this.utilsSvc.errorHandling(null);
        }
      }, (err) => {
        this._loaderSvc.stop();
        this.showGenericErrorPopup();
      });
    }
  }


  setRequestHeaders() {
    const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    let request: any = [];
    this.multiLineHeaders.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
    this.multiLineHeaders.requests = [];
    this.multiLineHeaders.targetServiceName = SUSPEND_CONSTANTS.SUSPEND_SERVICE;
    for (const line of this.suspendendeLines) {
      const element = line;
      const requests = new Requests();
      requests.orgId = this.orgId;
      requests.msisdn = element.msisdn;
      requests.reasonCode = element.reasonCode;
      requests.suspendStartDate = element.suspendStartDate;
      this.setDateForHeaders(element, requests);
      requests.extendContract = true;
      requests.logonId = !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID;
      requests.email = !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID;
      this.validatorTypeRequest(element,requests);
    }
    request = this.multiLineHeaders;
    return request;
  }

  setDateForHeaders(element: any, requests: any) {
    if (!isNullOrUndefined(element) && !isNullOrUndefined(element.suspendStartDate) &&
      element.suspendStartDate !== '') {
      requests.suspendStartDate = this.datePipe.transform(element.suspendStartDate, MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    } else {
      requests.suspendStartDate = this.datePipe.transform(new Date(), MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    }
    if (element.reasonCode !== MANAGE_LINE_CONST.ELST && element.reasonCode !== SUSPEND_CONSTANTS.RETENTION_SUSPEND) {
      requests.restoreDate = this.datePipe.transform(element.restoreDate, MANAGE_MODAL_CONST.DATE_FORMAT_FOR_CALL);
    }
    if (element.reasonCode == MANAGE_LINE_CONST.SUNC && (isNullOrUndefined(element.restoreDate) || element.restoreDate == '')) {
      requests.restoreDate = '';
    }
  }

  validatorTypeRequest(element,requests){
    if ((isNullOrUndefined(element.validatorType) || element.validatorType === '') && (element.reasonCode !== MANAGE_LINE_CONST.ELST && element.reasonCode !== SUSPEND_CONSTANTS.RETENTION_SUSPEND && element.reasonCode !==  MANAGE_LINE_CONST.SSQ)) {
      element.validatorType = element.approverType.description;
    }

    if (!isNullOrUndefined(element.validatorType) && element.reasonCode !==  MANAGE_LINE_CONST.SSQ && element.reasonCode !== MANAGE_LINE_CONST.ELST && element.reasonCode !== SUSPEND_CONSTANTS.RETENTION_SUSPEND) {
      requests.validatorType = this.convertApproverType(element.validatorType)
    }
    this.multiLineHeaders.requests.push(requests);
  }
  convertApproverType(approverType) {
    let tempApproverType;
    switch (approverType) {
      case SUSPEND_CONSTANTS.SENIOR_MANAGER:
        tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.SR_MANAGER;
        break;
      case SUSPEND_CONSTANTS.DIRECTOR:
        tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.DIRECTOR;
        break;
      case SUSPEND_CONSTANTS.VP:
        tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.VP;
        break;
      case SUSPEND_CONSTANTS.SALES_REP_INITIATED:
        tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.SALES_REP_INITIATED;
        break;
      case SUSPEND_CONSTANTS.B2B_MARKETING_MANAGER:
        tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.B2B_MARKETING_MANAGER;
        break;
      case SUSPEND_CONSTANTS.SALES_DIRECTOR:
        tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.SALES_DIRECTOR;
        break;
      case SUSPEND_CONSTANTS.CUSTOMER_INITIATED:
        tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.CUSTOMER_INITIATED;
        break;
      case SUSPEND_CONSTANTS.GOVERNMENT_SALES:
        tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.GOVERNMENT_SALES;
        break;
      case SUSPEND_CONSTANTS.PRICING_TEAM:
        tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.PRICING_TEAM;
        break;
      case SUSPEND_CONSTANTS.DIRECTOR_AND_VP:
          tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.DIRECTOR_AND_VP;
        break;
      case SUSPEND_CONSTANTS.SALES_VP_AND_QA_TEAM:
          tempApproverType = SUSPEND_CONSTANTS.APPROVER_TYPES.SALES_VP_AND_QA_TEAM;
        break;
    }
    return tempApproverType;

  }

  transferNumberData() {
    this.uploadJsonData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);
    this.transferNumberLines = this.uploadJsonData[0];
    this.linesWithError = this.uploadJsonData[1];
    this.tempLineWithError = Object.assign([], this.uploadJsonData[1]);
    this.makingModal();
  }

  changeNumberData() {
    this.uploadJsonData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);
    this.validChangeNumberLines = this.uploadJsonData[0];
    this.linesWithError = this.uploadJsonData[1];
    this.tempLineWithError = Object.assign([], this.uploadJsonData[1]);
    this.makingModalForChangeNumber();
  }

  checkingLineIDentifierValidation() {
    this.validLineIdentifierLines = this.bulkJsonData[0];
    this.linesWithError = this.bulkJsonData[1];
  }

  validateTransferNumber(line: any) {
    if (!isNullOrUndefined(line.tranNumber) && typeof (line.tranNumber) === 'string') {
      line.tranNumber = (line.tranNumber).replace(/\D/g, '');
    }
    if (this.validateNumberToTransferSameAsMSISDN(line) === false && this.validateDuplicateTransferNumber(line) === false) {
      if (!isNullOrUndefined(line.tranNumber) && line.tranNumber.toString().length === VALUE.TEN && !isNaN(+line.tranNumber)
        && +(line.tranNumber) !== line[BULK_UPLOAD.MSISDN_NUMBER_TXT]) {
        line.isNumberToTransferValid = true;
        this.checkCarrierNumberValid(line);
        if (!line.isCarrierNumberValid) {
          this.validateAccountNumber(line, true);
        }
        this.callsWhenPortDateNotValid(line);

        if (!line.isPortTimeValid) {
          this.validatePortTime(line);
        }


        if (line.isNumberToTransferValid === true && line.isCarrierNumberValid === true && line.isPortDateValid === true && !line.isLineTransformed) {
          line.isAccordionValidated = true;
          line.expendFlagValue = false;
          line.tranNumber = line.tranNumber.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
          this.transformValidatedLine(line);
          line.isErrorCountReduced = true;
        }
      } else {
        line.invalidTranNumber = true;
        line.isAccordionValidated = false;
        return false;
      }
    }
  }

  checkCarrierNumberValid(line){
    if (!line.isCarrierNumberValid) {
      this.validateAccountNumber(line, true);
    }
  }

  isLengthValid(line: any) {
    if (!isNullOrUndefined(line.tranNumber) && typeof (line.tranNumber) === 'string') {
      const val = line.tranNumber.replace(/\D/g, '');
      if (val.length === VALUE.TEN) {
        return true;
      } else if (val.length < 10) {
        line.isNumberToTransferValid = false;
        return false;
      }
    }
  }

  transformValidatedLine(line: any) {
    if (!isNullOrUndefined(this.tempLineWithError)) {
      const index = this.tempLineWithError.indexOf(line);
      const transformValidLine = this.tempLineWithError.splice(index, 1);
      const tranformedTranNumber = !isNullOrUndefined(transformValidLine[0].tranNumber) ? transformValidLine[0].tranNumber.replace(/\D/g, '') : '';
      transformValidLine[0][BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] = !isNullOrUndefined(tranformedTranNumber) ? +(tranformedTranNumber) : '';
      transformValidLine[0][BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER] = !isNullOrUndefined(transformValidLine[0].carrierNumber) ? (transformValidLine[0].carrierNumber) : '';
      transformValidLine[0][BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD] = !isNullOrUndefined(transformValidLine[0].accountPinPass) ? (transformValidLine[0].accountPinPass) : '';
      transformValidLine[0][BULK_UPLOAD.PORT_DATE_TXT] = !isNullOrUndefined(transformValidLine[0].portDate) ? (transformValidLine[0].portDate) : '';
      transformValidLine[0][BULK_UPLOAD.PORT_START_TIME_TXT] = !isNullOrUndefined(transformValidLine[0].portTime) ? (transformValidLine[0].portTime) : '';

      const validLine = transformValidLine.map((obj: any) => ({
        [BULK_UPLOAD.MSISDN_NUMBER_TXT]: +(obj[BULK_UPLOAD.MSISDN_NUMBER_TXT]),
        [BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]: +(obj[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]),
        [BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER]: obj.carrierNumber,
        [BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD]: obj.accountPinPass,
        [BULK_UPLOAD.PORT_DATE_TXT]: this.transformPortDate(obj),
        [BULK_UPLOAD.PORT_START_TIME_TXT]: obj.portTime
      }));
      this.transferNumberLines.push(...validLine);
      line.isLineTransformed = true;
    }
  }

  validateDuplicateTransferNumber(line: any) {
    const tempData = Object.assign([], this.linesWithError);
    const tranNumber = (line.tranNumber).replace(/\D/g, '');
    if (!isNullOrUndefined(tranNumber) && tranNumber !== '') {
      const duplicate = tempData.filter((item: any) => {
        if (item.tranNumber !== '') {
          return (item.tranNumber.replace(/\D/g, '')).includes(tranNumber);
        }
      });
      const duplicate2 = tempData.filter((obj: any) => {
        if (obj.tranNumber !== '') {
          return +(tranNumber).includes(obj[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]);
        }
      });
      if (duplicate.length > VALUE.ONE || duplicate2.length > VALUE.ONE) {
        line.numberToTfrDuplicate = true;
        return true;
      } else {
        line.numberToTfrDuplicate = false;
        return false;
      }
    }
  }

  validateNumberToTransferSameAsMSISDN(line: any) {
    const tempData1 = Object.assign([], this.linesWithError);
    const tempData2 = Object.assign([], this.transferNumberLines);
    const tranNumber = (line.tranNumber).replace(/\D/g, '');
    const transferNumberDuplicateOfMSISDN = tempData1.filter((obj: any) => obj.msisdn === tranNumber);
    const isTransferNumberDuplicateofMSISDN = transferNumberDuplicateOfMSISDN.some((obj: any) => obj.msisdn === tranNumber);
    const transferNumberDuplicateOfMSISDN2 = tempData2.filter((obj: any) => (obj[BULK_UPLOAD.MSISDN_NUMBER_TXT]).toString() === tranNumber);
    const isTransferNumberDuplicateofMSISDN2 = transferNumberDuplicateOfMSISDN2.some((obj: any) => (obj[BULK_UPLOAD.MSISDN_NUMBER_TXT]).toString() === tranNumber);
    if (isTransferNumberDuplicateofMSISDN || isTransferNumberDuplicateofMSISDN2) {
      line.isSameAsMSISDN = true;
      return line.isSameAsMSISDN;
    } else {
      line.isSameAsMSISDN = false;
      return line.isSameAsMSISDN;
    }
  }

  validateAccountNumber(line: any, param?: boolean) {
    line.missingCarrierNumber = true;
    if (!isNullOrUndefined(line) && !isNullOrUndefined(line.carrierNumber)) {
      line.isCarrierNumberValid = line.carrierNumber && line.carrierNumber.toString().length >= VALUE.ONE && line.carrierNumber.toString().length <= VALUE.THIRTY;
      if (line.isCarrierNumberValid) {
        if ((!line.isNumberToTransferValid || line.isNumberToTransferValid === false) || line.numberToTfrDuplicate && isNullOrUndefined(param)) {
          this.validateTransferNumber(line);
        }
       this.callsWhenPortDateNotValid(line);
       this.callsWhenPortTimeNotValid(line);

        if ((line.isCarrierNumberValid === true && line.isNumberToTransferValid === true && line.numberToTfrDuplicate === false && line.isSameAsMSISDN === false && line.isPortDateValid === true && line.isPortTimeValid === true  && !line.isLineTransformed) && isNullOrUndefined(param) && !line.isErrorCountReduced) {
          line.isAccordionValidated = true;
          line.expendFlagValue = false;
          this.isLineValidated = true;
          this.transformValidatedLine(line);
        }
      }
    }
  }

  callsWhenPortTimeNotValid(line){
    if (!line.isPortTimeValid) {
      this.validatePortTime(line);
    } 
  }

  callsWhenPortDateNotValid(line){
    if (!line.isPortDateValid) {
      this.validatePortDate(line);
    }
  }

  validatePortDate(line: any) {
    const pstDateResponse = ContentService.GetCache(COMMON_CONSTANTS.PORT_IN_PST_DATE);
    const currentDate = pstDateResponse.currentPstDate;
    const logicalDate = pstDateResponse.portInMaxDate;
    if (!isNullOrUndefined(line) && !isNullOrUndefined(line.portDate) && line.portDate !== '') {
      line.portDate = typeof (line.portDate) === 'object' ? this.transformPortDate(line) : line.portDate;
      this.assignPortDate(line,currentDate,logicalDate);
    } else {
      line.missingPortDate = true;
      line.isPortDateValid = null;
    }
  }
  assignPortDate(line,currentDate,logicalDate){
    if (new Date(line.portDate) >= new Date(currentDate) && new Date(line.portDate) <= new Date(logicalDate)) {
      line.portDate = this.portDate(line.portDate);
      line.isPortDateValid = true;
      line.isPortDateInValidFormat = true;
      line.missingPortDate = null;
      if (!line.isNumberToTransferValid) {
        this.validateTransferNumber(line);
      }
      if (!line.isCarrierNumberValid) {
        this.validateAccountNumber(line);
      }

      if (line.isNumberToTransferValid === true && line.numberToTfrDuplicate === false && line.isSameAsMSISDN === false && line.isCarrierNumberValid === true  && !line.isLineTransformed) {
        line.isAccordionValidated = true;
        line.expendFlagValue = false;
        this.transformValidatedLine(line);
      }
    } else {
      if (line.isPortDateInValidFormat !== false) {
        line.isPortDateValid = false;
        line.missingPortDate = null;
        line.portDate = this.portDate(line.portDate);
      }
    }
  }

  validatePortTime(line: any) {
    if (!isNullOrUndefined(line) && !isNullOrUndefined(line.portTime) && line.portTime !== '') {
      if (line.portTime.indexOf(COMMON_CONSTANTS.SYMBOLS.COLON) !== -1) {
        const splitTime = line.portTime.split(COMMON_CONSTANTS.SYMBOLS.COLON);
        if (splitTime.length != COMMON_CONSTANTS.DIGITS.THREE || (splitTime[0] == '' || splitTime[1] == '' || splitTime[2] == '')) {
          line.isPortTimeValid = false; // Time must be in HR:MIN:SS AM/PM format
        } else {
          if (splitTime.length == COMMON_CONSTANTS.DIGITS.THREE) {
            const splitSeconds = splitTime[2].split(' ')
            if (splitSeconds.length == COMMON_CONSTANTS.DIGITS.TWO && splitSeconds[0] != '' &&
              (splitSeconds[1] == MANAGE_MODAL_CONST.AM || splitSeconds[1] == MANAGE_MODAL_CONST.PM)) {
              if (splitTime[0] > COMMON_CONSTANTS.DIGITS.TWELVE || splitTime[1] >= COMMON_CONSTANTS.DIGITS.SIXTY || splitSeconds[0] >= COMMON_CONSTANTS.DIGITS.SIXTY) {
                line.isPortTimeInEligible = false; //Ineligible port time
              } else {
                const pstDateResponse = ContentService.GetCache(COMMON_CONSTANTS.PORT_IN_PST_DATE);
                const currentDate = pstDateResponse.currentPstDate;
                const portDate = `${String(line.portDate.month).padStart(2, '0')}/${String(line.portDate.day).padStart(2, '0')}/${line.portDate.year}`;
                const currentDateime = pstDateResponse.currentPstDateTime;
                const portDateTime = this.utilsSvc.getPortInDateTime(portDate, line.portTime);
                if (new Date(portDate).getDate() === new Date(currentDate).getDate()) {
                  if (new Date(portDateTime).getTime() > new Date(currentDateime).getTime()) {
                    line.isPortTimeInEligible = true;
                    line.isPortTimeValid = true;

                    if (!line.isNumberToTransferValid) {
                      this.validateTransferNumber(line);
                    }
                    if (!line.isCarrierNumberValid) {
                      this.validateAccountNumber(line);
                    }
                    if (!line.isPortDateValid) {
                      this.validatePortDate(line);
                    }
                    if (line.isCarrierNumberValid === true && line.isNumberToTransferValid === true && line.numberToTfrDuplicate === false && line.isSameAsMSISDN === false && line.isPortDateValid === true && line.isPortTimeValid === true && !line.isLineTransformed) {
                      line.isAccordionValidated = true;
                      line.expendFlagValue = false;
                      this.isLineValidated = true;
                      this.transformValidatedLine(line);
                    }
                  }
                  else {
                    this.showTimeErrorBelowReviewStatement = true;
                    line.isPortTimeInEligible = false;
                  }
                }
              }
            } else {
              line.isPortTimeValid = false;
            }
          } else {
            line.isPortTimeValid = false;
          }
        }
      }
      else {
        line.isPortTimeValid = false
      }
    } else {
      line.missingPortTime = true;
      line.isPortTimeValid = true;
      line.isPortTimeInEligible = true;
    }
  }

  calenderDateToUTC(objDate) {
    const today = new Date();
    const finalTime = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    return (new Date(objDate.month + '/' + objDate.day + '/' + objDate.year + ' ' + finalTime)).toISOString();
  }

  downloadErrorSpreadheet() {
    const dataWithErrors = this.linesWithError;
    const errorTemplate = [];
    let sheetName;
    switch (this.bulkFlow) {
      case BULK_UPLOAD.TRANSFER_NUMBERS:
        sheetName = BULK_UPLOAD.TRANSFER_NUMBER_ERROR_DOWNLOAD;
        if (!isNullOrUndefined(dataWithErrors)) {
          this.downloadErrorSpreadheetForTransferNumber(dataWithErrors,errorTemplate);
        }
        break;
      case BULK_UPLOAD.CHANGE_PHONE_KEY:
        sheetName = BULK_UPLOAD.CHANGE_NUMBER_ERROR_DOWNLOAD;
        if (!isNullOrUndefined(dataWithErrors)) {
          this.downloadErrorSpreadheetForChangePhoneKey(dataWithErrors,errorTemplate);
        }
        break;
      case BULK_UPLOAD.SIM_SWAP_KEY:
        if(this.eSimEnabled){
          sheetName = BULK_UPLOAD.ESIM_SWAP_ERROR_DOWNLOAD;
        }else{
          sheetName = BULK_UPLOAD.SIM_SWAP_ERROR_DOWNLOAD;
        }
        if (!isNullOrUndefined(dataWithErrors)) {
          this.downloadErrorSpreadheetForSimSwap(dataWithErrors,errorTemplate);
        }
        break;
      case BULK_UPLOAD.SUSPEND_KEY:
        sheetName = BULK_UPLOAD.SUSPEND_ERROR_DOWNLOAD;
        if (!isNullOrUndefined(dataWithErrors)) {
          this.downloadErrorSpreadheetForSuspend(dataWithErrors,errorTemplate);
        }
        break;
      case BULK_UPLOAD.RESTORE_KEY:
        sheetName = BULK_UPLOAD.RESTORE_SUCCESS_DOWNLOAD;
        if (!isNullOrUndefined(dataWithErrors)) {
          this.downloadErrorSpreadheetForRestore(dataWithErrors,errorTemplate);
        }
        break;
      case BULK_UPLOAD.CANCEL_SUBSCRIBER:
        sheetName = BULK_UPLOAD.CANCEL_SUBSCRIBER_ERROR_DOWNLOAD;
        this.downloadErrorSpreadsheetForCancelSubscriber(dataWithErrors, errorTemplate);
        break;
      case BULK_UPLOAD.CHANGE_SERVICE:
        sheetName = BULK_UPLOAD.CHANGE_SERVICE_ERROR_DOWNLOAD;
        this.downloadErrorSpreadsheetForChangeService(dataWithErrors, errorTemplate);
        break
      case BULK_UPLOAD.MANAGE_PAIRING:
        sheetName = BULK_UPLOAD.MANAGE_PAIRING_ERROR_DOWNLOAD;
        this.downloadErrorSpreadsheetForManagePairing(dataWithErrors, errorTemplate);
        break;
      case BULK_UPLOAD.STRATEGIC_PORT_IN:
        sheetName = BULK_UPLOAD.STRATEGIC_PORT_IN_ERROR_DOWNLOAD;
        this.downloadErrorSpreadsheetForStrategicPortIn(dataWithErrors, errorTemplate);
        break;
    }

    this.exportSvc.exportAsExcelFile(errorTemplate, sheetName);
  }

  downloadErrorSpreadsheetForChangeService(dataWithErrors, errorTemplate) {
    let temp: any;
    for (const obj of dataWithErrors) {
      // Dynamic columns based on selected SOCs
      const columnKeys = Object.keys(obj);
      temp = {};
      for (const key of columnKeys) {
        if (key == 'errorMsg') {
          temp[BULK_UPLOAD.ERROR_KEY] = obj.errorMsg;
        } else if (key == 'errorValidator' || key == 'expendFlagValue' || key == 'msgShowOnPanel' || key == 'succesValidator') {
          // Do not add these to download column
          continue;
        } else {
          temp[key] = obj[key];
        }
      }
      errorTemplate.push(temp);
    }
  }

  downloadErrorSpreadsheetForCancelSubscriber(dataWithErrors, errorTemplate) {
    let temp: any;
    for (const obj of dataWithErrors) {
      temp = {};
      temp[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] = obj.PhoneNumber;
      temp[BULK_UPLOAD.CANCEL_DATE] = obj.Cancel_date;
      temp[BULK_UPLOAD.CANCEL_REASON] = obj.Cancel_reason;
      temp[BULK_UPLOAD.ERROR_KEY] = obj.errorMsg
      errorTemplate.push(temp);
    }
  }

  downloadErrorSpreadheetForTransferNumber(dataWithErrors,errorTemplate){
    let temp:any;
    for (const element of dataWithErrors) {
      const line = element;
      temp = {};
      temp[BULK_UPLOAD.MSISDN_NUMBER_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.MSISDN_NUMBER_TXT]) ? line[BULK_UPLOAD.MSISDN_NUMBER_TXT] : '';
      temp[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]) ? line[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT] : '';
      temp[BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER] = !isNullOrUndefined(line[BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER]) ? line[BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER] : '';
      temp[BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD] = !isNullOrUndefined(line[BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD]) ? line[BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD] : '';
      temp[BULK_UPLOAD.PORT_DATE_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.PORT_DATE_TXT]) ? this.formatYear(line[BULK_UPLOAD.PORT_DATE_TXT]) : '';
      temp[BULK_UPLOAD.PORT_START_TIME_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.PORT_START_TIME_TXT]) ? line[BULK_UPLOAD.PORT_START_TIME_TXT] : '';
      temp[BULK_UPLOAD.ERROR_KEY] = !isNullOrUndefined(line[BULK_UPLOAD.ERROR_KEY]) ? line[BULK_UPLOAD.ERROR_KEY] : '';
      errorTemplate.push(temp);
    }
  }
  downloadErrorSpreadheetForChangePhoneKey(dataWithErrors,errorTemplate){
    let temp:any;
    for (const element of dataWithErrors) {
      const line = element;
      temp = {};
      temp[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT]) ? line[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] : '';
      temp[BULK_UPLOAD.PREFERRED_AREA_CODE] = !isNullOrUndefined(line[BULK_UPLOAD.PREFERRED_AREA_CODE]) ? line[BULK_UPLOAD.PREFERRED_AREA_CODE] : '';
      temp[BULK_UPLOAD.CHANGE_NUMBER_REASON_FOR_CHANGE_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.CHANGE_NUMBER_REASON_FOR_CHANGE_TXT]) ?
        line[BULK_UPLOAD.CHANGE_NUMBER_REASON_FOR_CHANGE_TXT] : '';
      temp[BULK_UPLOAD.ERROR_KEY] = !isNullOrUndefined(line[BULK_UPLOAD.ERROR_KEY]) ? line[BULK_UPLOAD.ERROR_KEY] : '';
      errorTemplate.push(temp);
    }
  }
  downloadErrorSpreadheetForSimSwap(dataWithErrors,errorTemplate){
    let temp:any;
    for (const element of dataWithErrors) {
      const line = element;
      temp = {};
      temp[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT]) ? line[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] : '';
      temp[BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt]) ? line[BULK_UPLOAD.BULK_SIMSWAP_OLDSIM_Txt] : '';
      this.dataWithErrorsEIDandNewSim(temp,line);
      temp[BULK_UPLOAD.BULK_SIMSWAP_REASON_FOR_CHANGE_Txt] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_SIMSWAP_REASON_FOR_CHANGE_Txt]) ?
        line[BULK_UPLOAD.BULK_SIMSWAP_REASON_FOR_CHANGE_Txt] : '';
      temp[BULK_UPLOAD.ERROR_KEY] = !isNullOrUndefined(line[BULK_UPLOAD.ERROR_KEY]) ? line[BULK_UPLOAD.ERROR_KEY] : '';
      errorTemplate.push(temp);
    }
  }
  dataWithErrorsEIDandNewSim(temp,line){
    if(this.eSimEnabled){
      temp[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt]) ? line[BULK_UPLOAD.BULK_SIMSWAP_EID_Txt] : '';
      temp[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt]) ? line[BULK_UPLOAD.BULK_ESIMSWAP_NEWSIM_Txt] : '';
    }else{
      temp[BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt]) ? line[BULK_UPLOAD.BULK_SIMSWAP_NEWSIM_Txt] : '';
    }
  }
  downloadErrorSpreadheetForSuspend(dataWithErrors,errorTemplate){
    let temp:any;
    for (const element of dataWithErrors) {
      const line = element;
      temp = {};
      temp[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.SUSPEND_MSISDN]) ? line[BULK_UPLOAD.SUSPEND_MSISDN] : '';
      temp[BULK_UPLOAD.BULK_SUSPEND_REASON_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.SUSPEND_REASONCODE]) ? this.getSuspendReasonCode(line[BULK_UPLOAD.SUSPEND_REASONCODE]) : '';
      temp[BULK_UPLOAD.BULK_SUSPEND_APPROVER_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.SUSPEND_VALIDATORTYPE]) ? line[BULK_UPLOAD.SUSPEND_VALIDATORTYPE] : '';
      temp[BULK_UPLOAD.BULK_SUSPEND_STARTDATE_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.SUSPEND_STARTDATE]) ? this.formatYear(line[BULK_UPLOAD.SUSPEND_STARTDATE]) : '';
      temp[BULK_UPLOAD.BULK_SUSPEND_ENDDATE_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.SUSPEND_ENDDATE]) ? this.formatYear(line[BULK_UPLOAD.SUSPEND_ENDDATE]) : '';
      temp[BULK_UPLOAD.ERROR_KEY] = !isNullOrUndefined(line[BULK_UPLOAD.SUSPEND_ERR_MSG]) ? line[BULK_UPLOAD.SUSPEND_ERR_MSG] : '';
      errorTemplate.push(temp);
    }
  }
  downloadErrorSpreadheetForRestore(dataWithErrors,errorTemplate){
    let temp:any;
    for (const element of dataWithErrors) {
      const line = element;
      temp = {};
      temp[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT]) ? Number(line[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT]) : '';
      temp[BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE] = !isNullOrUndefined(line[BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE]) ? this.formatYear(line[BULK_UPLOAD.BULK_UPLOAD_RESTORE_DATE]) : '';
      temp[BULK_UPLOAD.ERROR_MSG] = !isNullOrUndefined(line[BULK_UPLOAD.ERROR_MSG]) ? line[BULK_UPLOAD.ERROR_MSG] : '';
      errorTemplate.push(temp);
    }
  }
  formatYear(date: string) {
    if (date !== '' && !isNullOrUndefined(date)) {
      const arraySplit = date.split(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
      if (!isNullOrUndefined(arraySplit[2]) && ((arraySplit[2]).toString()).length === 2) {
        const year = VALUE.TWENTY + arraySplit[2];
        arraySplit[2] = year;
        return arraySplit.join(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
      } else {
        return date;
      }
    } else {
      return '';
    }
  }

  formatNumberToTransfer(tranNumber: number) {
    let formattedValue;
    const oldValue = !isNullOrUndefined(tranNumber) ? (tranNumber).toString() : '';
    if (oldValue.length === VALUE.TEN) {
      formattedValue = oldValue.replace(/\D/g, '');
      if (formattedValue.length === VALUE.TEN) {
        formattedValue = formattedValue.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
      }
      return formattedValue;
    } else {
      if (oldValue === '0') {
        return '';
      } else {
        return oldValue;
      }
    }
  }
  currentDate(currentDate){
    if (!isNullOrUndefined(currentDate) && !isNullOrUndefined(currentDate.currentPstDate) && !isNullOrUndefined(currentDate.portInMaxDate)) {
      const finalDate = currentDate.currentPstDate.split(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
      if (!isNullOrUndefined(finalDate) && !isNullOrUndefined(finalDate.length) && finalDate.length !== COMMON_CONSTANTS.DIGITS.ZERO ) {
        this.minimumTransferDate = {
          year: Number(finalDate[2]),
          month: Number(finalDate[0]),
          day: Number(finalDate[1]),
        };
      }
    }
  }
  makingModal() {
    const currentDate = ContentService.GetCache(COMMON_CONSTANTS.PORT_IN_PST_DATE);
    this.currentDate(currentDate);
    this.linesWithError.forEach((line) => {
      line.msisdn = line[BULK_UPLOAD.MSISDN_NUMBER_TXT].toString();
      line.tranNumber = this.formatNumberToTransfer(line[BULK_UPLOAD.NUMBER_TO_TRANSFER_TXT]);
      line.carrierNumber = line[BULK_UPLOAD.CARRIER_ACCOUNT_NUMBER];
      line.accountPinPass = line[BULK_UPLOAD.ACCOUNT_PIN_OR_PASSWORD];
      line.portDate = this.portDate(line[BULK_UPLOAD.PORT_DATE_TXT]);
      line.portTime = line[BULK_UPLOAD.PORT_START_TIME_TXT];
      line.expendFlagValue = true;
      const tempTranNumber = line.tranNumber.replace(/\D/g, '');
      if (tempTranNumber.length > VALUE.TEN || (tempTranNumber.length < VALUE.TEN && tempTranNumber.length > VALUE.ZERO)) {
        line.invalidTranNumber = true;
      } else {
        line.invalidTranNumber = false;
        line.isNumberToTransferValid = true;
      }
      if (!isNullOrUndefined(line) && !isNullOrUndefined(line.carrierNumber)) {
        if (line.carrierNumber && line.carrierNumber.toString().length >= VALUE.ONE && line.carrierNumber.toString().length <= VALUE.THIRTY) {
          line.isCarrierNumberValid = true;
        } else {
          line.isCarrierNumberValid = false;
        }
      } else {
        line.missingCarrierNumber = true;
      }
      this.validateNumberToTransferSameAsMSISDN(line);
      const currDate = currentDate.currentPstDate;
      const logicalDate = currentDate.portInMaxDate;
      const portDate = line[BULK_UPLOAD.PORT_DATE_TXT];
      const finalMaxDate = logicalDate.split(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
      this.maximumTransferDate = {
        year: Number(finalMaxDate[2]),
        month: Number(finalMaxDate[0]),
        day: Number(finalMaxDate[1]),
      };
      // Port Date Validations
      this.makingModalPortDateValidations(line,portDate,currDate,logicalDate);
      //Port Start Time Validations
      this.makingModalPortTimeValidations(line);
    });
  }
  makingModalPortDateValidations(line,portDate,currDate,logicalDate){
    if (!isNullOrUndefined(line.portDate) && line.portDate !== '') {
      if ((line[BULK_UPLOAD.PORT_DATE_TXT]).indexOf(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH) !== -1) {
        let splitDate = line[BULK_UPLOAD.PORT_DATE_TXT].split(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
        if (splitDate.length == COMMON_CONSTANTS.DIGITS.THREE) {
          this.splitDateLengthThree(splitDate,portDate,currDate,logicalDate,line);
        }else {
          line.isPortDateInValidFormat = false;
        }
      } else {
        line.isPortDateInValidFormat = false;
      }
    } else {
      line.missingPortDate = true;
    }
  }
  splitDateLengthThree(splitDate,portDate,currDate,logicalDate,line){
    let dateRegex = COMMON_CONSTANTS.DATE_REGEX;
    if(!dateRegex.test(portDate)){
      line.isPortDateInValidFormat = false;
    }else if (new Date(portDate) < new Date(currDate) || new Date(portDate) > new Date(logicalDate)) {
      line.isPortDateValid = false; //Ineligible port date
    }else {
      this.transferNumberDateValidation(splitDate,line);
    }
  }
  transferNumberDateValidation(splitDate,line){
    if (line[BULK_UPLOAD.PORT_DATE_TXT]) {
      splitDate = line[BULK_UPLOAD.PORT_DATE_TXT].split(COMMON_CONSTANTS.SYMBOLS.FORWARD_SLASH);
      if (splitDate.length !== COMMON_CONSTANTS.DIGITS.THREE) {
        line.isPortDateInValidFormat = false; //Port date must be in MM/DD/YYYY format
      }
      else {
        if (splitDate[0] > COMMON_CONSTANTS.DIGITS.TWELVE || splitDate[1] > COMMON_CONSTANTS.DIGITS.THIRTY_ONE) {
          line.isPortDateValid = false;
        } else {
          line.isPortDateInValidFormat = true;
        }
      }
    }
  }
  makingModalPortTimeValidations(line){
    if (!isNullOrUndefined(line.portTime) && line.portTime !== '') {
      if (line.portTime.indexOf(COMMON_CONSTANTS.SYMBOLS.COLON) != -1) {
        const splitTime = line.portTime.split(COMMON_CONSTANTS.SYMBOLS.COLON);
        if (splitTime.length != COMMON_CONSTANTS.DIGITS.THREE || (splitTime[0] == '' || splitTime[1] == '' || splitTime[2] == '')) {
          line.isPortTimeValid = false; // Time must be in HR:MIN:SS AM/PM format
        } else {
          if (splitTime.length === COMMON_CONSTANTS.DIGITS.THREE) {
            const splitSeconds = splitTime[2].split(' ')
            this.validateSplitSeconds(line, splitSeconds, splitTime)
          } else {
            line.isPortTimeValid = false;
          }

        }
      }
      else {
        line.isPortTimeValid = false;
      }
    } else {
      line.missingPortTime = true;
      line.isPortTimeValid = true;
      line.isPortTimeInEligible = true;
    }

  }

  validateSplitSeconds(line, splitSeconds, splitTime){
    if (splitSeconds.length == COMMON_CONSTANTS.DIGITS.TWO && splitSeconds[0] != '' &&
      (splitSeconds[1] == MANAGE_MODAL_CONST.AM || splitSeconds[1] == MANAGE_MODAL_CONST.PM)) {
      if (splitTime[0] > COMMON_CONSTANTS.DIGITS.TWELVE || splitTime[1] >= COMMON_CONSTANTS.DIGITS.SIXTY || splitSeconds[0] >= COMMON_CONSTANTS.DIGITS.SIXTY) {
        line.isPortTimeInEligible = false; //Ineligible port time
      } else {
        const pstDateResponse = ContentService.GetCache(COMMON_CONSTANTS.PORT_IN_PST_DATE);
        const currentDate = pstDateResponse.currentPstDate;
        const portDate = line[BULK_UPLOAD.PORT_DATE_TXT];
        const currentDateime = pstDateResponse.currentPstDateTime;
        const portDateTime = this.utilsSvc.getPortInDateTime(portDate, line.portTime);
        if (new Date(portDate).getDate() === new Date(currentDate).getDate()) {
          if (new Date(portDateTime).getTime() > new Date(currentDateime).getTime()) {
            line.isPortTimeInEligible = true;
          }
          else{
            this.showTimeErrorBelowReviewStatement = true;
            line.isPortTimeInEligible = false;
          }
        }
      }
    } else {
      line.isPortTimeValid = false;
    }
  }
  makingModalForChangeNumber() {
    this.linesWithError.forEach((line) => {
      line.msisdn = line[BULK_UPLOAD.BULK_PHONE_NUMBER_TXT].toString();
      line.areaCode = line[BULK_UPLOAD.PREFERRED_AREA_CODE];
      line.reasonForChange = line[BULK_UPLOAD.BULK_SIMSWAP_REASON_FOR_CHANGE_Txt];
      line.expendFlagValue = true;
      if (line.errorValidator !== null || line.errorValidator !== undefined) {
        line.errorValidator = true;
      }
      if (line.succesValidator !== null || line.succesValidator !== undefined) {
        line.succesValidator = false;
      }
      if (line.validated !== null || line.validated !== undefined) {
        line.errorValidator = false;
      }
    });
  }

  transformPortDate(line: any, temp?: boolean) {
    if (!isNullOrUndefined(line) && line.portDate !== '') {
      const portDate = line.portDate.month + '/' + line.portDate.day + '/' + line.portDate.year;
      if (temp === true && typeof (line.portDate) === 'object') {
        line.portDate = portDate;
        this.validatePortDate(line);
      }
      return portDate;
    }
  }

  portDate(portDateExcel) {
    if (!isNullOrUndefined(portDateExcel) && portDateExcel !== '') {
      const arraySplit = portDateExcel.split('/');
      return {
        year: Number(arraySplit[2]), month: Number(arraySplit[0]),
        day: Number(arraySplit[1]),
      };
    } else {
      return '';
    }
  }

  removeTransferNumber(line) {
    if (!isNullOrUndefined(line) && !isNullOrUndefined(this.linesWithError) && !isNullOrUndefined(this.tempLineWithError)) {
      const index = this.linesWithError.indexOf(line);
      this.linesWithError.splice(index, 1);
      this.tempLineWithError.splice(index, 1);
    }
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.REMOVE_NUMBER,
      assetType: ANALYTICS.LINK,
      modalName: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt + this.authoringContentData.transferNumberAuthoring.results,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt
    });
  }

  toggleText(ref) {
    if (ref.type === this.authoringContentData.bulkFlow.password) {
      ref.type = this.authoringContentData.bulkFlow.text;
    } else {
      ref.type = this.authoringContentData.bulkFlow.password;
    }
  }

  submitTransferNumberRequest() {
    this.portinLines = this.transferNumberLines;
    this.requestPortin = this.utilsSvc.updatedPortinBulkRequestHeader(this.portinLines);
    this.requestPortin.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
    this.requestPortin.targetServiceName = SIM_CHANGE_CONST.PORTIN_TXT;
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      container: '#am-container-custom',
    };
    this._loaderSvc.start();
    this.manageLineService.bulkTransferNumberProcessor(this.requestPortin).subscribe((data) => {
      this._loaderSvc.stop();
      if (!isNullOrUndefined(data) && !isNullOrUndefined(data.status) && data.status === SIM_CHANGE_CONST.SUCCESS) {
        this.manageLineService.close();
        this.submitBulkTransferNumTag();
        const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
        successModalRef.componentInstance.tagEnabledByCaller = true;
        successModalRef.componentInstance.nameTag = this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt;
        successModalRef.componentInstance.modalBodyContent = this.authoringContentData.transferNumberAuthoring.confirmationMsgTxt
          .replace('{{emailID}}', _.get(JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.EUI_TOKEN_DATA)), 'logonId', ''));
        successModalRef.componentInstance.isPortIn = true;
        successModalRef.componentInstance.bulkUploadFlow = true;
        successModalRef.componentInstance.header = this.authoringContentData.transferNumberAuthoring.bulkLineSuccessModalTitle;
        // tslint:disable-next-line: max-line-length
        successModalRef.componentInstance.portInSuccessTransaction = this.authoringContentData.transferNumberAuthoring.bulktransactionNumberTxt
          .replace('{{transID}}', data.token);
        successModalRef.componentInstance.transactionID = data.token;
      } else {
        this.utilsSvc.errorHandling(null);
        this._loaderSvc.stop();
      }
    }, (error) => {
      this.showError(error);
    });
  }

  submitBulkTransferNumTag() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.SUBMIT,
      assetType: ANALYTICS.BUTTON,
      modalName: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt + this.authoringContentData.transferNumberAuthoring.results,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt
    });
  }

  generateModalViewTag() {
    let dynamicContent = this.linesWithError.length + this.authoringContentData.bulkFlow.bulkInlineflowIssuesTxt;
    if (this.validChangeNumberLines.length > 0) {
      dynamicContent = this.validChangeNumberLines.length + this.authoringContentData.bulkFlow.itemsUploadedSuccessfullyText;
    }
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt + this.authoringContentData.transferNumberAuthoring.results,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt,
      dynamicContent
    });
  }

  matPanelOpenCloseClickTag(openOrClosed) {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.LINE_NUMBER,
      assetType: openOrClosed,
      modalName: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt + this.authoringContentData.transferNumberAuthoring.results,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt
    });
  }

  calendarClickTag() {
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_ACTION,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.TRANSFER_DATE_SELECTOR,
      assetType: ANALYTICS.ICON,
      modalName: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt + this.authoringContentData.transferNumberAuthoring.results,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt
    });
  }

  cancelBulkNumberTransfer() {
    this.manageLineService.close()

    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CANCEL,
      assetType: ANALYTICS.BUTTON,
      modalName: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt + this.authoringContentData.transferNumberAuthoring.results,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt
    });
  }


  closeBulkNumberTransferXTag() {
    this.manageLineService.close();

    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.CLOSE,
      assetType: ANALYTICS.LINK,
      modalName: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt + this.authoringContentData.transferNumberAuthoring.results,
      stage: ANALYTICS.INPROGRESSSTAGE,
      name: this.authoringContentData.bulkFlow.bulkUploadTransferNumberTitleTxt
    });
  }

  checkingChangeServiceValidation() {
    this.uploadJsonData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);

    const availableServices = JSON.parse(this._cacheSvc.getFromSessionStorage(BULK_UPLOAD.CATALOG_SERVICES))
    const mobileNumberSet = this.getSelectedBanMsisdns();

    let tempKeys;
    for (const service of this.uploadJsonData) {
      if (mobileNumberSet.size != 0 && !mobileNumberSet.has(service.PhoneNumber)) {
        service.errorValidator = true;
        service.succesValidator = false;
        service.errorMsg = EXCEL_JS.ERROR_BAN_MSISDN_MISMATCH;
        this.linesWithError.push(service);
        continue;
      }

      tempKeys = Object.keys(service);
      // Since SOCs are dynamic we need to iterate through each
      let containsInvalidValues = false;
      const invalidServiceColumns = [];
      for (const columnKey of tempKeys) {
        if (columnKey !== BULK_UPLOAD.PHONE_NUMBER_TXT) {
          if (availableServices[columnKey.toLowerCase()] === undefined) {
            invalidServiceColumns.push(columnKey)
          } else {
            const data = service[columnKey].trim().toLowerCase();
            if (['add', 'remove', ''].indexOf(data) === -1) {
              containsInvalidValues = true;
            }
          }
        }
      }

      if (invalidServiceColumns.length > 0) {
        service.errorValidator = true;
        service.succesValidator = false;
        service.errorMsg = 'Invalid Service(s): ' + invalidServiceColumns.join(',');
        this.linesWithError.push(service);
        continue;
      }

      if (containsInvalidValues) {
        service.errorValidator = true;
        service.succesValidator = false;
        service.errorMsg = EXCEL_JS.ERROR_CHANGE_SERVICES_INVALID_INPUT;
        this.linesWithError.push(service);
        continue;
      }

      this.changeServices.push(service);
    }

    this.runPreSubmitCheckForChangeService();
  }


  submitChangeServiceDataAfterUpload() {
    this.linesWithErrorDuplicate = []
    if (this.changeServices.length > 0) {

      this.requests = [];
      /**
       * Number of columns is dynamic but at this point each request
       * should have the same columns.
       */
      const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
      const services = JSON.parse(this._cacheSvc.getFromSessionStorage(BULK_UPLOAD.CATALOG_SERVICES));
      const columns = Object.keys(this.changeServices[0]);
      let addServices;
      let removeServices;
      for (const request of this.changeServices) {
        addServices = [];
        removeServices = [];

        // Collect add or remove services in file upload
        for (const column of columns) {
          if (column != BULK_UPLOAD.BULK_PHONE_NUMBER_TXT) {
            // Grab service details
            const serviceInfo = services[column.toLowerCase()];
            let effectiveDateType = 'N';
            if(environment.ENABLE_SPECTRUM){
              effectiveDateType = ['ZBLOCKMI','MBBWEBGRD'].includes(serviceInfo?.items[0]?.partNumber)? 'T': 'N';
            }
            // Inputdata should only have values Add, Remove, or an empty string
            const inputData = request[column].toLowerCase();
            if (inputData == 'add') {
              addServices.push({
                'serviceCode': serviceInfo.items[0]?.partNumber,
                'serviceSequenceNumber': '',
                'level': COMMON_CONSTANTS.SERVICE_LEVEL.SUBSCRIBER,
                'effectiveDateType': effectiveDateType,
                'serviceName': serviceInfo.skuName
              });
            } else if (inputData == 'remove') {
              removeServices.push({
                'serviceCode': serviceInfo.items[0]?.partNumber,
                'serviceSequenceNumber': '',
                'level': COMMON_CONSTANTS.SERVICE_LEVEL.SUBSCRIBER,
                'effectiveDateType': effectiveDateType,
                'serviceName': serviceInfo.skuName
              });
            }
          }
        }
        this.requests.push({
          "msisdn": request.PhoneNumber,
          "addServices": addServices,
          "removeServices": removeServices,
          "logonId": !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID,
          "email": !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID,
          "orgId":  this._helperUtilSvc.getOrgID(),
          "ban": this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN)
        });
      }

      this.requestBody = {
        "targetServiceName": BULK_UPLOAD.CHANGE_SERVICE,
        "requests": this.requests,
        "ban": this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN)
      };
      this._loaderSvc.start();
      this.isLoaderOn = true;
      this.manageLineService.bulkChangeServiceProcessor(this.requestBody).subscribe((response) => {
        this._loaderSvc.stop();
        this.isLoaderOn = false;
        if (!isNullOrUndefined(response) && !isNullOrUndefined(response.status)
          && response.status === MANAGE_LINE_CONST.SUCCESS) {
          this.results = response;
          this.manageLineService.close();
          const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
          successModalRef.componentInstance.token = response.token;
          successModalRef.componentInstance.header = this.authoringContentData.manageLine.changeServiceRequestComplete;
          successModalRef.componentInstance.bulkUploadFlow = true;
          successModalRef.componentInstance.isConfirmationPopup = false;
          successModalRef.componentInstance.isChangeService = true;
          successModalRef.componentInstance.bulkChangeServiceData = this.changeServices;
          successModalRef.componentInstance.flowType = BULK_UPLOAD.CHANGE_SERVICE;
        } else {
          this.manageLineService.close();
          this.utilsSvc.errorHandling(undefined);
        }
      }, (err) => {
        this._loaderSvc.stop();
        this.showGenericErrorPopup();
      });
    }
  }

  makeCancelSubscriberReasonCodeMap() {
    const map = {};
    for(const reason of CANCEL_SUBSCRIBER_REASONS) {
      map[reason.description] = reason.code;
    }
    return map;
  }

  runPreSubmitCheckForCancelSubscriber() {
    if (!isNullOrUndefined(this.linesWithError) && this.linesWithError.length > 0) {
      const currentDate = new Date();
      this.minimumDate = { year: currentDate.getFullYear(), month: currentDate.getMonth() + 1, day: currentDate.getDate() };
      this.validationError = true;
      this.blkUpldSubmittitle = this.cancelLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.cancelLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.expansionPanelOpened(this.linesWithError[0]);
    }

    if (!isNullOrUndefined(this.cancelLines) && this.cancelLines.length > 0 && this.linesWithError.length == 0) {
      this.blkUpldSubmittitle = this.cancelLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.cancelLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
    }

    if (!isNullOrUndefined(this.cancelLines) && this.cancelLines.length === 0) {
      this.termsAndConditionCheckBox = true;
    } else {
      this.termsAndConditionCheckBox = false;
    }
  }

  runPreSubmitCheckForChangeService() {
    if (!isNullOrUndefined(this.linesWithError) && this.linesWithError.length > 0) {
      this.validationError = true;
      this.blkUpldSubmittitle = this.changeServices.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.changeServices.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.expansionPanelOpened(this.linesWithError[0]);
    }

    if (!isNullOrUndefined(this.changeServices) && this.changeServices.length > 0 && this.linesWithError.length == 0) {
      this.blkUpldSubmittitle = this.changeServices.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.changeServices.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
    }

    if (!isNullOrUndefined(this.changeServices) && this.changeServices.length === 0) {
      this.termsAndConditionCheckBox = true;
    } else {
      this.termsAndConditionCheckBox = false;
    }
  }

  ServiceAgreement(selectedFlow) {
    if (selectedFlow == 'cancelSubscriber') {
      const modalRef = this.modalService.open(ConfirmOrCancelModalComponent, this.ngbModalOptions);
      modalRef.componentInstance.title = 'Agreement';
      modalRef.componentInstance.body = 'By submitting this Bulk Change Service transaction you agree to the updated billing based on services selected.';
      modalRef.componentInstance.cancelBtnTxt = this.authoringContentData.cancelService.cancelCTA;
      modalRef.componentInstance.confirmBtnTxt = this.authoringContentData.cancelService.balanceDueConfirm;
      modalRef.componentInstance.dismissAllOnClose = true;
    }
  }

  checkingManagePairingValidation() {
    this.uploadJsonData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);

    const mobileNumberSet = this.getSelectedBanMsisdns();

    for (const line of this.uploadJsonData) {
      //removing special characters from voice and watch line
      let { Voice_Line, Watch_Line } = this.getNumericValueOfVoiceAndWatchLines(line[BULK_UPLOAD.MNG_PAIRING_MOBILE_LINE], line[BULK_UPLOAD.MNG_PAIRING_DIGITS_LINE]);

      // Check valid MSISDN pattern
      if (!this.utilsSvc.validMobileNumberPattern(Voice_Line)) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_INVALID_VOICE_NUMBER;
        this.linesWithError.push(line);
        continue;
      }
      // Check valid DIGITs pattern
      if (!this.utilsSvc.validMobileNumberPattern(Watch_Line)) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_INVALID_DIGITs_NUMBER;
        this.linesWithError.push(line);
        continue;
      }

      // Check MSISDN belongs to BAN
      if (mobileNumberSet.size != 0 && !mobileNumberSet.has(Voice_Line)) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_BAN_VOICE_MISMATCH;
        this.linesWithError.push(line);
        continue;
      }

      // Check DIGITs belong to BAN
      if (mobileNumberSet.size != 0 && !mobileNumberSet.has(Watch_Line)) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_BAN_DIGITS_MISMATCH;
        this.linesWithError.push(line);
        continue;
      }

      // Check ACTION has valid values
      if (!BULK_UPLOAD.MANAGE_PAIRING_ACTIONS.includes(line[BULK_UPLOAD.MNG_PAIRING_ACTION])) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_MANAGE_PAIRING_INVALID_ACTION;
        this.linesWithError.push(line);
        continue;
      }

      line.errorValidator = false;
      line.succesValidator = true;
      //assigning the unformatted msisdn values to the line object
      line[BULK_UPLOAD.MNG_PAIRING_MOBILE_LINE] = Voice_Line;
      line[BULK_UPLOAD.MNG_PAIRING_DIGITS_LINE] = Watch_Line;
      this.managePairLines.push(line);
    }
    this.runPreSubmitCheckForManagePairing();
  }

  getNumericValueOfVoiceAndWatchLines(Voice_Line : any, Watch_Line: any){
    if(Voice_Line){
      Voice_Line = Voice_Line.replace(/\D/g, '');
    }
    if(Watch_Line){
      Watch_Line = Watch_Line.replace(/\D/g, '');
    }
    return { Voice_Line, Watch_Line };
  }

  runPreSubmitCheckForManagePairing() {
    if (!isNullOrUndefined(this.linesWithError) && this.linesWithError.length > 0) {
      this.validationError = true;
      this.blkUpldSubmittitle = this.managePairLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.managePairLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.expansionPanelOpened(this.linesWithError[0]);
    }

    if (!isNullOrUndefined(this.managePairLines) && this.managePairLines.length > 0 && this.linesWithError.length == 0) {
      this.blkUpldSubmittitle = this.managePairLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.managePairLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
    }

    if (!isNullOrUndefined(this.managePairLines) && this.managePairLines.length === 0) {
      this.termsAndConditionCheckBox = true;
    } else {
      this.termsAndConditionCheckBox = false;
    }
  }

  submitManagePairingDataAfterUpload() {
    this.linesWithErrorDuplicate = []
    if (this.managePairLines.length > 0) {
      const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));

      for (const jsonData of this.managePairLines) {
        this.requests.push({
          "gsmLine": jsonData['Voice_Line'],
          "digitsLine": jsonData['Watch_Line'],
          "action": jsonData['Action'].toUpperCase(),
          "billingAccount": this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN),
          "orgId": this._helperUtilSvc.getOrgID(),
          "logonId": !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID,
          "email": !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID
        });
      }
      this.requestBody = {
        "targetServiceName": BULK_UPLOAD.MANAGE_PAIRING,
        "ban": this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN),
        "requests": this.requests,
      };
      this._loaderSvc.start();
      this.isLoaderOn = true;

      this.manageLineService.submitBulkRequest(this.requestBody).subscribe((response) => {
        this._loaderSvc.stop();
        this.isLoaderOn = false;
        if (!isNullOrUndefined(response) && !isNullOrUndefined(response.status)
          && response.status === MANAGE_LINE_CONST.SUCCESS) {
          this.results = response;
          this.manageLineService.close();
          const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
          successModalRef.componentInstance.token = response.token;
          successModalRef.componentInstance.header = this.authoringContentData.managePairing.managePairingRequestComplete;
          successModalRef.componentInstance.bulkUploadFlow = true;
          successModalRef.componentInstance.isConfirmationPopup = false;
          successModalRef.componentInstance.bulkManagePairingData = this.requestBody.requests;
          successModalRef.componentInstance.flowType = BULK_UPLOAD.MANAGE_PAIRING;
        } else {
          this.manageLineService.close();
          this.utilsSvc.errorHandling(null);
        }
      }, (err) => {
        this._loaderSvc.stop();
        this.showGenericErrorPopup();
      });
    }
  }

  downloadErrorSpreadsheetForManagePairing(dataWithErrors, errorTemplate) {
    let temp: any;

    for (const obj of dataWithErrors) {
      temp = {};
      temp[BULK_UPLOAD.MNG_PAIRING_MOBILE_LINE] = obj[BULK_UPLOAD.MNG_PAIRING_MOBILE_LINE];
      temp[BULK_UPLOAD.MNG_PAIRING_DIGITS_LINE] = obj[BULK_UPLOAD.MNG_PAIRING_DIGITS_LINE];
      temp[BULK_UPLOAD.MNG_PAIRING_ACTION] = obj[BULK_UPLOAD.MNG_PAIRING_ACTION];
      temp[BULK_UPLOAD.ERROR_KEY] = obj.errorMsg;
      errorTemplate.push(temp);
    }
  }

  showGenericErrorPopup() {
    this.manageLineService.close();
    const alertConfirmPopupRef = this.modalService.open(AlertConfirmPopupComponent, this.ngbModalOptions);
    alertConfirmPopupRef.componentInstance.title = GENERIC_ERROR_MSGS.INTERNAL_ERR;
    alertConfirmPopupRef.componentInstance.message = GENERIC_ERROR_MSGS.INTERNAL_SERVER_ERR;
    alertConfirmPopupRef.componentInstance.btnOkText = COMMON_CONSTANTS.OK;
  }


  checkingStrategicPortInValidation() {
    this.uploadJsonData = ContentService.GetCache(BULK_UPLOAD.BULK_UPLOAD_REQUEST_KEY);

    const mobileNumberSet = this.getSelectedBanMsisdns();
    const msisdnsAlreadyInReq = new Set();

    for (const line of this.uploadJsonData) {
      // Check valid MSISDN pattern
      if (!this.utilsSvc.validMobileNumberPattern(line[BULK_UPLOAD.STRATEGIC_PORT_IN_TMO_MSISDN])) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_INVALID_PHONE_NUMBER;
        this.linesWithError.push(line);
        continue;
      }
      // Check valid MSISDN pattern
      if (!this.utilsSvc.validMobileNumberPattern(line[BULK_UPLOAD.STRATEGIC_PORT_IN_TEMP_MSISDN])) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_INVALID_PHONE_NUMBER;
        this.linesWithError.push(line);
        continue;
      }

      // Check MSISDN belongs to BAN
      if (mobileNumberSet.size != 0 && !mobileNumberSet.has((line[BULK_UPLOAD.STRATEGIC_PORT_IN_TMO_MSISDN]).replace(/\D/g, ''))) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_BAN_MSISDN_MISMATCH;
        this.linesWithError.push(line);
        continue;
      }

      if (msisdnsAlreadyInReq.has(line[BULK_UPLOAD.STRATEGIC_PORT_IN_TMO_MSISDN])) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_TMO_TEMP_MSISDN_ALREADY_IN_REQUEST;
        this.linesWithError.push(line);
        continue;
      }

      if (msisdnsAlreadyInReq.has(line[BULK_UPLOAD.STRATEGIC_PORT_IN_TEMP_MSISDN])) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_PORTIN_MSISDN_ALREADY_IN_REQUEST;
        this.linesWithError.push(line);
        continue;
      }

      // If carrier number is not between 1 and 30 characters
      if (!(line[BULK_UPLOAD.STRATEGIC_PORT_IN_CARRIER_ACC_NUM]?.trim()?.length <= 30 && line[BULK_UPLOAD.STRATEGIC_PORT_IN_CARRIER_ACC_NUM]?.trim()?.length > 0)) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_INVALID_CARRIER_ACC_NUM;
        this.linesWithError.push(line);
        continue;
      }

      if (!(line[BULK_UPLOAD.STRATEGIC_PORT_IN_ACC_PIN]?.trim()?.length <= 30 && line[BULK_UPLOAD.STRATEGIC_PORT_IN_ACC_PIN]?.trim()?.length > 0)) {
        line.errorValidator = true;
        line.succesValidator = false;
        line.errorMsg = EXCEL_JS.ERROR_INVALID_ACC_PIN_PASSWORD;
        this.linesWithError.push(line);
        continue;
      }

      msisdnsAlreadyInReq.add(line[BULK_UPLOAD.STRATEGIC_PORT_IN_TMO_MSISDN]);
      msisdnsAlreadyInReq.add(line[BULK_UPLOAD.STRATEGIC_PORT_IN_TEMP_MSISDN]);

      line.errorValidator = false;
      line.succesValidator = true;
      this.strategicPortInLines.push(line);
    }
    this.runPreSubmitCheckForStrategicPortIn();
  }

  runPreSubmitCheckForStrategicPortIn() {
    if (!isNullOrUndefined(this.linesWithError) && this.linesWithError.length > 0) {
      this.validationError = true;
      this.blkUpldSubmittitle = this.strategicPortInLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.strategicPortInLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.expansionPanelOpened(this.linesWithError[0]);
    }

    if (!isNullOrUndefined(this.strategicPortInLines) && this.strategicPortInLines.length > 0 && this.linesWithError.length == 0) {
      this.blkUpldSubmittitle = this.strategicPortInLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedTxt +
        this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
      this.reviewMsg = this.authoringContentData.manageLineRestore.bulkReviewTxt;
      this.itemLoadedSuccfully = this.strategicPortInLines.length + this.authoringContentData.manageLineRestore.bulkItemLoadedSuccesTxt;
      this.itmeNotLoadeSuccefully = this.linesWithError.length + this.authoringContentData.manageLineRestore.bulkIssueFoundTxt;
    }

    if (!isNullOrUndefined(this.strategicPortInLines) && this.strategicPortInLines.length === 0) {
      this.termsAndConditionCheckBox = true;
    } else {
      this.termsAndConditionCheckBox = false;
    }
  }

  downloadErrorSpreadsheetForStrategicPortIn(dataWithErrors, errorTemplate) {
    let temp: any;

    for (const obj of dataWithErrors) {
      temp = {};

      temp[BULK_UPLOAD.STRATEGIC_PORT_IN_TMO_MSISDN] = obj[BULK_UPLOAD.STRATEGIC_PORT_IN_TMO_MSISDN];
      temp[BULK_UPLOAD.STRATEGIC_PORT_IN_TEMP_MSISDN] = obj[BULK_UPLOAD.STRATEGIC_PORT_IN_TEMP_MSISDN];
      temp[BULK_UPLOAD.STRATEGIC_PORT_IN_CARRIER_ACC_NUM] = obj[BULK_UPLOAD.STRATEGIC_PORT_IN_CARRIER_ACC_NUM];
      // To protect users from storing pins in error sheet, do not put password in error sheet
      temp[BULK_UPLOAD.STRATEGIC_PORT_IN_ACC_PIN] = BULK_UPLOAD.STRATEGIC_PORT_IN_REMOVED_PIN_TXT;
      temp[BULK_UPLOAD.ERROR_KEY] = obj.errorMsg;

      errorTemplate.push(temp);
    }
  }

  encryptPasswords(key) {
    const encryptPromises = [];
    for (const jsonData of this.strategicPortInLines) {
      const headerParams = { alg: 'RSA-OAEP-256', enc: 'A256GCM' };
      const encodedOspPwd = new TextEncoder().encode(jsonData['Account Pin or Password']);

      encryptPromises.push(new jose.CompactEncrypt(encodedOspPwd).setProtectedHeader(headerParams).encrypt(key as jose.KeyLike))
    }
    return encryptPromises;
  }

  submitStrategicPortInRequest(publicKey) {
    jose.importSPKI(publicKey, 'RSA-OAEP-256').then((key) => {
      const encryptPromises = this.encryptPasswords(key);

      combineLatest(encryptPromises).subscribe((encryptedPasswords) => {
        const authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));

        for(let i = 0; i < encryptedPasswords.length; i++) {
            this.requests.push({
              "logonId": !isNullOrUndefined(authInfo) ? authInfo.logonID : COMMON_CONSTANTS.LOGON_ID,
              "orgId": this._helperUtilSvc.getOrgID(),
              "email": !isNullOrUndefined(authInfo) ? authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID,
              "msisdn": (this.strategicPortInLines[i]['T-Mobile MSISDN']).replace(/\D/g, ''),
              "newMsisdn": (this.strategicPortInLines[i]['Number to transfer']).replace(/\D/g, ''),
              "reasonCode": TRANSFER_NUMBER_CONSTANTS.REASON_CODE_PR,
              "ospAccountPassword": "{cipher}" + encryptedPasswords[i],
              "ospAccount": this.strategicPortInLines[i]['Carrier account number']
          });
        }

        this.requestBody = {
          "targetServiceName": BULK_UPLOAD.STRATEGIC_PORT_IN,
          "requests": this.requests,
          "ban": this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN)
        };
        this.submitStrategicPortIn();
      });
    });
  }

  submitStrategicPortIn() {
    this._loaderSvc.start();
    this.isLoaderOn = true;

    this.manageLineService.submitBulkRequest(this.requestBody).subscribe((response) => {
      this.isLoaderOn = false;
      if (!isNullOrUndefined(response) && !isNullOrUndefined(response.status)
        && response.status === MANAGE_LINE_CONST.SUCCESS) {
        this.results = response;
        this.manageLineService.close();
        const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
        successModalRef.componentInstance.token = response.token;
        successModalRef.componentInstance.header = this.authoringContentData.strategicPortIn.bulkSuccessTitle;
        successModalRef.componentInstance.bulkUploadFlow = true;
        successModalRef.componentInstance.isConfirmationPopup = false;
        successModalRef.componentInstance.bulkStrategicPortInData = this.requestBody.requests;
        successModalRef.componentInstance.flowType = BULK_UPLOAD.STRATEGIC_PORT_IN;
      } else {
        this.manageLineService.close();
        this.utilsSvc.errorHandling(null);
      }
    }, (err) => {
      this.showGenericErrorPopup();
    });
  }
  submitStrategicPortInDataAfterUpload() {
    this.linesWithErrorDuplicate = [];
    if (this.strategicPortInLines.length > 0) {
      this.manageLineService.getStrategicPortInPubKey().subscribe((response) => {
        this.submitStrategicPortInRequest(response?.customerKey);
      },(error)=>{
        this.utilsSvc.errorHandling(error);
      })
    }
  }

  goToTransactions() {
    this.manageLineService.close();
    this.router.navigate([MANAGE_LINE_CONST.REDIRECT_TO_TRANSACTION_HISTORY]);
  }
}
